import React, { useState, useEffect, useCallback, useRef } from "react";
import { useHistory } from "react-router-dom";
import debounce from "lodash/debounce";
import { SelectBox } from 'devextreme-react/select-box';
import AccordionReact from 'devextreme-react/accordion';
import { TabPanel, Item as TabItem } from 'devextreme-react/tab-panel';
import { Button } from 'devextreme-react/button';
import { alert, confirm, custom } from 'devextreme/ui/dialog';
import { GridLayout } from "../../common/GridLayout";
import { Localization } from "../../common/Localization";
import notify from 'devextreme/ui/notify';
import LookupPopup from './LookupPopup';
import LookupProfilePopup from './LookupProfilePopup';
import DeleteReceiptDialog from "./DeleteReceiptDialog";
import DataSource from "devextreme/data/data_source";
import ArrayStore from "devextreme/data/array_store";
import { TextBox } from 'devextreme-react/text-box';
import { TextArea } from 'devextreme-react';
import ItemModeGrid from "./ItemModeGrid";
import DateBox from 'devextreme-react/date-box';
import ToolbarAccordian, { Item as ItemAccordian } from "devextreme-react/toolbar";
import { LoadPanel } from 'devextreme-react/load-panel';
import { LoadIndicator } from 'devextreme-react/load-indicator';
import {
  Column,
  DataGrid,
  GroupPanel,
  Grouping,
  FilterRow,
  FilterPanel,
  Sorting,
  Paging,
  Pager,
  Export,
  ColumnHeaderFilter,
  ColumnChooser,
  ColumnChooserSearch,
  Selection,
  HeaderFilter,
  Editing,
  ColumnFixing,
  StateStoring,
  Toolbar,
  Item,
  Scrolling
} from "devextreme-react/data-grid";
import { useDispatch } from "react-redux";
import { connect } from "react-redux";
import axios from "axios";
import data from "../../assets/apiRoutes.json";
import { Reset_Items } from "../../redux/actions/receipt";
import * as PermissionsConstants from "../../const/constants";
import { Popup } from "devextreme-react/popup";
import Consignee from "./consignee/AddConsignee";
import ScrollView from "devextreme-react/scroll-view";
import { createStore } from 'devextreme-aspnet-data-nojquery';
import { createConcurrencyAwareStore, refreshGridOnConflict } from "../../common/dataStore";
import { CONCURRENCY_HANDLED, getApiErrorMessage } from "../../common/concurrency";
import { disableTransDate, ABECASUSER_LOGIN_TYPE } from "../../common/permissions";
import GridLayoutManager from "../../gridLayoutCustomization/GridLayoutManager";
import { GetFormatedDateWithTime } from '../../common/Utils';
import { MESSAGES } from '../../common/Messages';
import './wmmodulestyle.css';

var receiptIdVar = "";
var dialogMessage1 = "";
var dialogMessage2 = "";
var detailDataGridMode = "ExpressLotMode";
var detailItemDataGridMode = "ItemMode";
var customerRowId = "";
let isAbecasUser = false;
var detailDataGrid = React.createRef();
var detailOrderedItemsDataGrid = React.createRef();
const searchpanel = [
  {
    ID: 1,
    Title: 'Search Filters'
  }
];
let profileObjt;
function CreateCustomerTransaction(props) {
  const consigneeLookup = 0;
  const shipperLookup = 1;
  const carrierLookup = 2;
  const customerLookup = 3;

  let detailDataGridModes;
  if (props.rolePermission === PermissionsConstants.TransactionReceipt) {
    detailDataGridModes = [
      { value: 'ExpressItemMode', text: 'Express Item Mode' },
      { value: 'ExpressLotMode', text: 'Express Lot Mode' },
      { value: 'ItemMode', text: 'Item Mode' },
    ];
  } else {
    detailDataGridModes = [
      { value: 'ExpressItemMode', text: 'Express Item Mode' },
      { value: 'ExpressLotMode', text: 'Express Lot Mode' },
    ];
  }
  const formatDate = (date) => {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  };
  const initialTransactionState = {
    recordNumber: "",
    shipperBolNumber: "",
    reference: "",
    userDefinedReference2: "",
    transactionNumber: "",
    transactionDate: new Date(),
    transactionGroup: "",
    actualreceivedshipeddate: "",
    rShipper: "",
    rConsignee: "",
    comment: "",
    rCarrier: "",
    shipperVal: "",
    consigneeVal: "",
    carrierVal: "",
    shipperId: "",
    consigneeId: "",
    carrierId: "",
    stage: "P",
    status: "O",
    companyid: "SB",
    module: "WM",
    freightChargeType: "N",
    transactionType:
      props.rolePermission === PermissionsConstants.TransactionReceipt
        ? "R"
        : "S",
    recordtype: "W",
    customerId: "",
    rCustomer: "",
    customerVal: "",
    profileId: "",
    rProfile: "",
    profileVal: ""
  };

  var setFoucsToLotFilterTextBox = false;
  isAbecasUser = props.oidc.user.profile.hasOwnProperty("LOGINTYPEID") && props.oidc.user.profile.LOGINTYPEID == ABECASUSER_LOGIN_TYPE;
  const [createBtnURL, setcreateBtnURL] = React.useState("/wm/transaction/create-receipt");
  const [shipperData, setshipperData] = useState({});
  const [carrierData, setCarrierData] = useState({});
  const [customerData, setCustomerData] = useState({});
  const [profileData, setProfileData] = useState({});
  const [guidForconsignee, setGuidForConsignee] = useState([]);
  const [guidForShipper, setGuidForShipper] = useState([]);
  const [guidForCarrier, setGuidForCarrier] = useState([]);
  const [guidForCustomer, setGuidForCustomer] = useState([]);
  const [guidForProfile, setGuidForProfile] = useState([]);
  const [searchPanelStatus, setSearchPanelStatus] = useState(true);
  const [displayItemModeGrid, setDisplayItemModeGrid] = useState(false);

  const [selectedItems, setSelectedItems] = useState([searchpanel[0]]);
  const [selectedBottomTabIndex, setSelectedBottomTabIndex] = useState(0);
  const [loadPanelVisible, setLoadPanelVisible] = useState(false);
  const [showIndicator, setShowIndicator] = useState(true);
  const [shading, setShading] = useState(true);
  const [showPane, setShowPane] = useState(true);
  const [hideOnOutsideClick, setHideOnOutsideClick] = useState(false);
  const position = { of: '#accordion-containe2' };
  const dataGrid = useRef(null);
  const profileDataGrid = React.createRef();
  const allowedPageSizes = [10, 100, 200, 500, "all"];
  var accessToken = props.oidc.user.access_token;
  const dispatch = useDispatch();
  const history = useHistory();
  const [consigneeData, setConsigneeData] = useState({});
  const [poError, setPOError] = useState("");
  const [customerError, setCustomerError] = useState("");
  const [profileError, setProfileError] = useState("");
  const [dialogToAddItems, setDialogToAddItems] = useState(false);
  const [disableReciveShippingDate, setdisableReciveShippingDate] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  const [dateError, setDateError] = useState("");
  const [consigneeIdInputToDisable, setConsigneeIdInputToDisable] =
    useState(false);
  const [consigneeInfoInputToDisable, setConsigneeInfoInputToDisable] =
    useState(false);
  const [consigneeSearchDisable, setConsigneeSearchDisable] = useState(false);
  const [consigneeInfo, setConsigneeInfo] = useState("");
  const [disable, setDisable] = useState(false);
  const [openDialogForTransaction, setOpenDialogForTransaction] =
    useState(false);
  const [addConsigneePopup, setaddConsigneePopup] = useState(false);
  const [selectedValue, setSelectedValue] = useState(detailDataGridMode);
  const [headerId, setHeaderId] = useState(receiptIdVar);
  const [selectedCustomerId, setSelectedCustomerId] = useState();
  const [consigneeIdPopupValue, setConsigneeIdPopupValue] = useState("");
  const [loadIndicatorVisible, setLoadIndicatorVisible] = useState(false);
  const [deleteButtonDisabled, setDeleteButtonDisabled] = useState(true);
  const [deleteReceiptDialogOpen, setDeleteReceiptDialogOpen] = useState(false);
  const [allowedReceiptDeleteBtn, setAllowedReceiptDeleteBtn] = useState(false);
  const [allowedShipmentDeleteBtn, setAllowedShipmentDeleteBtn] = useState(false);
  const [disableShippingDate, setDisableShippingDate] = useState(false);
  const [detailCount, setDetailCount] = useState(0);
  const [customerDisabled, setCustomerDisabled] = useState(false);
  const [profileDisabled, setProfileDisabled] = useState(false);
  const [reloadKey, setReloadKey] = useState(0);
  const [dataSource, setDataSource] = useState(null);
  const [selectedAvailableItem, setSelectedAvailableItem] = useState(null);
  const [addToOrderButtonDisabled, setAddToOrderButtonDisabled] = useState(true);
  const [selectedOrderedItem, setSelectedOrderedItem] = useState(null);
  const [removeFromOrderButtonDisabled, setRemoveFromOrderButtonDisabled] = useState(true);
  const [orderedItems, setOrderedItems] = useState([]);
  const [isOrderCompleted, setIsOrderCompleted] = useState(false);
  const availableItemsGridRef = useRef(null);
  const detailDataGridModeChanged = (e) => {
    if (e.value == "ItemMode") {
      setHeaderId(receiptIdVar);
      setDisplayItemModeGrid(true);
      setSelectedValue(e.value);
      detailItemDataGridMode = e.value;
      setReloadKey(prevKey => prevKey + 1);
    } else {
      setDisplayItemModeGrid(false);
      detailDataGridMode = e.value;
      setSelectedValue(e.value);
      if (detailDataGrid.current && typeof detailDataGrid.current.instance === 'function') {
        const instance = detailDataGrid.current.instance();
        if (instance && typeof instance.refresh === 'function') {
          instance.refresh();
        }
      }
    }
  }



  const handleOpenDeleteReceiptDialog = (e) => {
    e.event.stopPropagation();
    setDeleteReceiptDialogOpen(true);
  };

  const handleCloseDeleteReceiptDialog = () => {
    setDeleteReceiptDialogOpen(false);
  };

  const handelReset = () => {
    setDisable(false);
    setProfileDisabled(false);
    setCustomerDisabled(false);
    setPrintButtonDisabled(true);
    setDeleteButtonDisabled(true);
    setReceiptId("");
    receiptIdVar = "";
    setHeaderId(receiptIdVar);
    initialTransactionState.transactionDate = new Date();
    setTransaction(initialTransactionState);
    setProfileData({});
    setGuidForCarrier([]);
    setCarrierData({});
    setCustomerData({});
    customerRowId = "";
    setCarrierData({});
    setGuidForConsignee([]);
    setConsigneeData({});
    setConsigneeInfo("");
    setGuidForShipper([]);
    setshipperData({});

  }
  const SHIPPER_ID_TO = "shipperidto";
  const lookups = {};
  lookups[SHIPPER_ID_TO] = {
    name: "ShipperTo",
    label: "Shipper To:",
    lookupType: 5
  };
  const handleClosePopUpCallback = (ChildData) => {
    setConsigneeIdPopupValue(ChildData.rowid);
    setTransaction({
      ...transaction,
      consigneeId: ChildData.ridentity
    });

    setConsigneeData({
      rowid: ChildData.ridentity,
      name: ChildData.name,
      identityId: ChildData.identityid,
    });

    setConsigneeInfo(getConsigneeInfo(ChildData));
    setaddConsigneePopup(false);
    console.log(ChildData);
  };

  const exportReport = (e) => {
    e.event.stopPropagation();
    var report = new Object();
    report.Key = "WMR0049";
    report.Name = "WMR0049";

    var whereInfo = new Object();
    whereInfo.FieldType = 0; //ParameterTypeEnum.String;
    whereInfo.FieldName = "TRANSACTIONNUMBER";
    whereInfo.Operation = 3; //OperationEnum.Equal
    whereInfo.Origin = "WMTRANSACTIONHEADER.TRANSACTIONNUMBER";
    whereInfo.From = transaction.transactionNumber;
    whereInfo.To = transaction.transactionNumber;
    report.FilterWhereInfoList = [];
    report.FilterWhereInfoList.push(whereInfo);
    setLoadIndicatorVisible(true);
    axios
      .post(
        `${window._env_.REACT_APP_APIS}/${data.reports.GenerateReport}`,
        report,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
        }
      )
      .then((res) => {
        setLoadIndicatorVisible(false);
        if (
          res.hasOwnProperty("data") &&
          res.data != null &&
          res.data != undefined
        ) {
          if (res.data.isSuccess) {
            window.open(
              `${window._env_.REACT_APP_APIS}/${data.reports.GetReportFile}?fileName=${res.data.fileName}`,
              "_blank"
            );
          } else {
            alert(
              `${MESSAGES.ERROR_GENERATING_REPORT}. Error: ${res.data.errorMessage}`,
              MESSAGES.ERROR
            );
          }
        } else {
          alert(MESSAGES.ERROR_GENERATING_REPORT, MESSAGES.ERROR);
        }
      })
      .catch((err) => {
        setLoadIndicatorVisible(false);
        alert(err, MESSAGES.ERROR);
      });
  };



  const [transaction, setTransaction] = useState(initialTransactionState);

  const dataBase =
    props.ReceiptReducer.wmTransactionDatabase !== ""
      ? props.ReceiptReducer.wmTransactionDatabase
      : "";

  const [transactionType, setTransactionType] = useState({
    transactionType:
      props.rolePermission === PermissionsConstants.TransactionReceipt
        ? "R"
        : props.permission === PermissionsConstants.TransactionAdjustment
          ? "A"
          : "S",
    dbName:
      props.ReceiptReducer.wmTransactionDatabase !== ""
        ? props.ReceiptReducer.wmTransactionDatabase
        : "",
  });

  const [printButtonDisabled, setPrintButtonDisabled] = useState(transaction?.transactionNumber ? false : true);


  const loadTransactionFromProfile = (profileId) => {
    ;
    console.log(profileData);

    axios
      .get(
        `${window._env_.REACT_APP_APIS}/${data.Receipt.GetTransactionFromProfile}?transactionType=${transactionType.transactionType}&profileId=${profileId}`,
        {
          headers: {
            "Content-Type": "application/json",
            access_token: accessToken,
            Authorization: `Bearer ${accessToken}`,
          },
        }
      )
      .then((res) => {
        if (res.hasOwnProperty("data") && res.data != null && res.data != undefined && res.data != "") {
          ;
          if (res.data.shipper != null && res.data.shipper != undefined) {

            let tempShipperArray = new Array();
            tempShipperArray.push(res.data.shipper);
            console.log(tempShipperArray);
            setGuidForShipper(tempShipperArray);
            console.log(res.data.shipper);
            setshipperData(res.data.shipper);
          }
          else {
            setGuidForShipper([]);
            setshipperData({});
          }

          if (res.data.carrier != null && res.data.carrier != undefined) {
            let tempCarrierArray = new Array();
            tempCarrierArray.push(res.data.carrier);
            setGuidForCarrier(tempCarrierArray);
            setCarrierData(res.data.carrier);
          }
          else {
            setGuidForCarrier([]);
            setCarrierData({});
          }

          if (res.data.consigneeInfo?.rowid != null && res.data.consigneeInfo?.rowid != undefined) {
            let tempConsigneeArray = new Array();
            tempConsigneeArray.push(res.data.consigneeInfo);
            setGuidForConsignee(tempConsigneeArray);
            setConsigneeData(res.data.consigneeInfo);
            setConsigneeInfo(res.data?.consigneeInfo?.info);
          }
          else {
            setGuidForConsignee([]);
            setConsigneeData({});
            setConsigneeInfo("");
          }

          if (res.data.customer != null && res.data.customer != undefined) {
            let tempCustomerArray = new Array();
            tempCustomerArray.push(res.data.customer);
            setGuidForCustomer(tempCustomerArray);
            setCustomerData(res.data.customer);
            customerRowId = res.data.customer.rowid;
            if (detailDataGrid.current?.instance()) {
              detailDataGrid.current.instance().refresh();
            }
          }
          else {
            setGuidForCustomer([]);
            setCustomerData({});
            customerRowId = "";
            if (detailDataGrid.current?.instance()) {
              detailDataGrid.current.instance().refresh();
            }
          }

          var data = transaction;
          data.shipperBolNumber = res.data.transaction?.shipperbolnumber;
          data.actualreceivedshipeddate = res.data.transaction?.actualreceivedshippeddatetime;
          data.comment = res.data.transaction?.comment;
          data.reference = res.data.transaction?.reference;
          data.carrierVal = res.data.carrier?.name;
          data.rCarrier = res.data.carrier?.rowid;
          data.shipperVal = res.data.shipper?.name;
          data.rShipper = res.data.shipper?.rowid;
          data.rConsignee = res.data.consigneeInfo?.rowid;
          data.consigneeVal = res.data.consigneeInfo?.name;
          data.freightChargeType = res.data.transaction?.freightchargetype;
          data.transactionGroup = res.data.transaction?.transactiongroup;
          data.customerVal = res.data.customer?.name;
          data.rCustomer = res.data.customer?.rowid;
          data.concurrencyToken = res.data.transaction?.concurrencyToken;
          setTransaction(data);
        }
      })
      .catch((err) => {
        console.log(err, "error in getting shipper from profile");
      });
  };

  const getTransactionData = () => {
    axios
      .post(
        `${window._env_.REACT_APP_APIS}/${data.Receipt.GetAllTransactions}`,
        transactionType,
        {
          headers: {
            "Content-Type": "application/json",
            access_token: accessToken,
            Authorization: `Bearer ${accessToken}`,
          },
        }
      )
      .then((res) => {
        props.loadTransactionsData(res.data);
      });
  };

  const handelShipperBolChange = (e) => {

    const name = "shipperBolNumber";
    const value = e.value;
    setTransaction((prevTransaction) => ({
      ...prevTransaction,
      [name]: value,
    }));
  };

  const handelCommentChange = (e) => {

    const name = "comment";
    const value = e.value;
    setTransaction((prevTransaction) => ({
      ...prevTransaction,
      [name]: value,
    }));
  };
  const handelreferenceChange = (e) => {

    const name = "reference";
    const value = e.value;
    setTransaction((prevTransaction) => ({
      ...prevTransaction,
      [name]: value,
    }));
  };


  const onInputValueChange = (e) => {

    const { name } = e.component.option('name');
    const value = e.value;
    if (name === "actualreceivedshipeddate") {
      // Check user permissions
      if (props.oidc.user.profile.hasOwnProperty("WMTRANSDATECONTROL") && props.oidc.user.profile.WMTRANSDATECONTROL === "B") {
        const compare = Date.parse(value);
        const today = Date.now(); // Use Date.now() to get the current timestamp
        if (compare < today) {
          alert(MESSAGES.RECEIVING_DATE_MUST_BE_GREATER, MESSAGES.ERROR);
          return;
        }
      }
    }
    if (name) {
      setTransaction({ ...transaction, [name]: value });
    }
  };
  const onInputChange = (e) => {


    if (e.target.name == "actualreceivedshipeddate") {
      if (props.oidc.user.profile.hasOwnProperty("WMTRANSDATECONTROL") && props.oidc.user.profile.WMTRANSDATECONTROL == "B") {
        var compare = Date.parse(e.target.value);
        var today = Date().now();
        if (compare < today) {
          alert(MESSAGES.RECEIVING_DATE_MUST_BE_GREATER, MESSAGES.ERROR);
          return;
        }
      }
    }

    setTransaction({ ...transaction, [e.target.name]: e.target.value });



  };

  const resetErrors = () => {
    setPOError("");
    setDateError("");
    setCustomerError("");
  };
  const [receiptId, setReceiptId] = useState("");

  const initialTotals = {
    items: 0.00,
    ordered: 0.00,
    netWeight: 0.00,
    actual: 0.00,
    grossWeight: 0.00,
    inventory: 0.00,
    amount: 0.00,
  };
  const [selectedTotals, setSelectedTotals] = useState(initialTotals);
  
  const changeTotals = async () => {
    try {
      if (!receiptId || receiptId === "00000000-0000-0000-0000-000000000000") {
        setSelectedTotals(initialTotals);
      } 
      else 
      {
        const response = await axios.get(`${window._env_.REACT_APP_APIS}/${data.Transaction.GetTotals}`, {
          params: { headerRowId: receiptId },
          headers: { access_token: accessToken, Authorization: `Bearer ${accessToken}` },
        });
        const result = response.data?.result || response.data;
        setSelectedTotals(result);
      }
    } catch (error) {
      console.error("Error fetching totals:", error);
    }
  }
  const handelUerDefinedReference2rChange = (e) => {

    const name = "userDefinedReference2";
    const value = e.value;
    setTransaction((prevTransaction) => ({
      ...prevTransaction,
      [name]: value,
    }));
  };

  const onSaveTransaction = (e) => {

    e.event.stopPropagation();
    let errors = [];

    if (transaction.reference === "") {
      setPOError("P.O. No field is required");
      errors.push("P.O. No field is required");
      notify(
        {
          message: "P.O. No field is required!",
          width: 100,
        },
        'error',
        3000,
      );
    } else {
      setPOError("");
    }

    if ((!transaction.transactionDate) || transaction.transactionDate === "") {
      setDateError("Date is required!");
      errors.push("Date is required!");
      notify(
        {
          message: "Date is required!",
          width: 100,
        },
        'error',
        3000,
      );
    } else {
      setDateError("");
    }

    if (props.oidc.user.profile.hasOwnProperty("LOGINTYPEID") && props.oidc.user.profile.LOGINTYPEID == ABECASUSER_LOGIN_TYPE) {
      if (profileData?.rowid == null || profileData?.rowid == undefined) {
        setProfileError("Profile is required");
        errors.push("Profile is required");
        notify(
          {
            message: "Profile is required",
            width: 100,
          },
          'error',
          3000,
        );
        return;
      } else {
        setProfileError("");
      }

      if (customerData?.rowid == null || customerData?.rowid == undefined) {
        setCustomerError("Customer is required");
        errors.push("Customer is required");
        notify(
          {
            message: "Customer is required",
            width: 100,
          },
          'error',
          3000,
        );
        return;
      } else {
        setCustomerError("");
      }
      if ((!transaction.reference) || transaction.reference === "") {
        setPOError("P.O. No field is required");
        errors.push("P.O. No field is required");
        notify(
          {
            message: "P.O. No field is required!",
            width: 100,
          },
          'error',
          3000,
        );
      } else {
        setPOError("");
      }
    }

    if (errors.length == 0) {
      /*
      if (receiptItemsObect.length === 0) {
        setDialogToAddItems(true);
      }
      */

      // if (receiptItemsObect.length > 0) {
      if (true) {
        setDisable(true);
        // dispatch(Create_New_Receipt(transactionDetailRequest));
        setLoadPanelVisible(true);
        var transactionDetailRequest = {
          // Tells the API which version of the header this edit started from.
          concurrencyToken: transaction.concurrencyToken,
          shipperBolNumber: transaction.shipperBolNumber,
          reference: transaction.reference,
          transactionNumber: transaction.transactionNumber,
          rShipper: shipperData?.rowid,
          comment: transaction.comment,
          rCarrier: carrierData?.rowid,
          rConsignee: consigneeData?.rowid,
          transactionDate: GetFormatedDateWithTime(transaction.transactionDate),
          actualreceivedshippeddatetime: GetFormatedDateWithTime(transaction.actualreceivedshipeddate),
          status: transaction.status,
          stage: transaction.stage,
          companyid: transaction.companyid,
          module: transaction.module,
          recordtype: transaction.recordtype,
          transactionType: transaction.transactionType,
          dbName: dataBase,
          freightChargeType: transaction.freightChargeType,
          transactionGroup: transaction.transactionGroup,
          rCustomer: props.oidc.user.profile.hasOwnProperty("LOGINTYPEID") && props.oidc.user.profile.LOGINTYPEID == ABECASUSER_LOGIN_TYPE ? customerData?.rowid : null,
          rProfile: profileData?.rowid,
          UserDefinedReference2: transaction.userDefinedReference2
        };

        if (props.oidc.user.profile.hasOwnProperty("RECVSHIPDTACCESS") && props.oidc.user.profile.RECVSHIPDTACCESS == "D") {
          transactionDetailRequest.actualreceivedshippeddatetime = null;
        }

        if (receiptIdVar != "") {
          transactionDetailRequest.rowid = receiptIdVar;
          setHeaderId(receiptIdVar);
        }

        axios.post
          (
            `${window._env_.REACT_APP_APIS}/${data.Receipt.ValidateReference}`,
            transactionDetailRequest,
            {
              headers: {
                "Content-Type": "application/json",
                access_token: accessToken,
              },
            }
          )
          .then((res) => {
            setTimeout(hideLoadPanel, 1000);
            if (res.data.type == "warning") {
              let result = confirm("<i>" + res.data.message + "</i>", MESSAGES.WARNING);
              result.then((dialogResult) => {
                if (dialogResult) {
                  SaveTransaction(transactionDetailRequest);
                }
                else {
                  setDisable(false);

                }
              });

            }
            else if (res.data.type == "error") {
              alert(res.data.message, MESSAGES.ERROR);
              setDisable(false);
            }
            else {
              SaveTransaction(transactionDetailRequest);
            }
          })
          .catch((err) => {
            setDisable(false);
            setTimeout(hideLoadPanel, 1000);
            alert(err, MESSAGES.ERROR);
          });
      }
    }
  };

  const SaveTransaction = (transactionDetailRequest) => {
    if (receiptIdVar == "") {
      axios.post
        (
          `${window._env_.REACT_APP_APIS}/${data.Receipt.CreateTransactions}`,
          transactionDetailRequest,
          {
            headers: {
              "Content-Type": "application/json",
              access_token: accessToken,
            },
          }
        )
        .then((res) => {
          // dispatch(onCheckBoxClick(res.data));
          if (res.data.success) {
            setProfileDisabled(true);
            setCustomerDisabled(true);
            setPrintButtonDisabled(false);
            setDeleteButtonDisabled(false);
            setReceiptId(res.data.wmtransactionheader.rowid);
            setTransaction({
              ...transaction,
              ["transactionNumber"]: res.data.wmtransactionheader.transactionnumber,
              ["recordNumber"]: res.data.wmtransactionheader.recordNumber
            });
            handleClickOpen();
            receiptIdVar = res.data.wmtransactionheader.rowid;
            setSelectedCustomerId(res.data.wmtransactionheader.rCustomer);
            setHeaderId(receiptIdVar);
            changeTotals();
            setDisable(false);
            resetErrors();
          }
          else {
            alert(res.data.message, MESSAGES.ERROR);
            setDisable(false);
            resetErrors();
            setPrintButtonDisabled(true);
          }
        })
        .catch((err) => {
          // A version conflict is already handled globally by the axios interceptor.
          if (err?.[CONCURRENCY_HANDLED]) {
              return;
          }
          // A refusal is now a real 4xx and lands here rather than in the else branch above; this catch
          // previously reset state without telling the user anything.
          alert(getApiErrorMessage(err, MESSAGES.ERROR), "Error");
          setDisable(false);
          resetErrors();
          setPrintButtonDisabled(true);
        });
    }
    else {
      axios.post
        (
          `${window._env_.REACT_APP_APIS}/${data.Receipt.UpdateTransactions}`,
          transactionDetailRequest,
          {
            headers: {
              "Content-Type": "application/json",
              access_token: accessToken,
              Authorization: `Bearer ${accessToken}`,
            },
          }
        )
        .then((res) => {
          if (res.data.success) {
            // Adopt the token for the version just written, or the next save echoes the one
            // this screen was opened with and falsely conflicts.
            if (res.data.wmtransactionheader?.concurrencyToken) {
              setTransaction((prev) => ({ ...prev, concurrencyToken: res.data.wmtransactionheader.concurrencyToken }));
            }
            handleClickOpen();
            setDisable(false);
            resetErrors();
          }
          else {
            alert(res.data.message, MESSAGES.ERROR);
            setDisable(false);
            resetErrors();
          }
        })
        .catch((err) => {
          // A real version conflict comes back as 409 and the shared interceptor has already
          // raised the reload dialog. Don't stack this screen's own error handling on top.
          if (err?.[CONCURRENCY_HANDLED]) {
            return;
          }
          // A refusal is now a real 4xx, so it lands here instead of the else branch above. This catch
          // previously reset state without telling the user anything.
          alert(getApiErrorMessage(err, MESSAGES.ERROR), "Error");
          setDisable(false);
          resetErrors();
        });
    }
  };

  const closeDialogForTransaction = () => {
    let itemArray = [];
    dispatch(Reset_Items(itemArray));
    //getTransactionData();
    handleClose();
    history.push("/wm/transaction");
  };

  const handleCompleteOrder = async (e) => {
    e.event.stopPropagation();
    
    if (!receiptId || receiptId === "") {
      alert(MESSAGES.PLEASE_SAVE_RECORD_FIRST, MESSAGES.ERROR);
      return;
    }

    try {
      setDisable(true);
      const response = await axios.post(
        `${window._env_.REACT_APP_APIS}/${data.Receipt.CompleteOrder}`,
        null,
        {
          headers: {
            "Content-Type": "application/json",
            access_token: accessToken,
            Authorization: `Bearer ${accessToken}`,
            Key: receiptId
          }
        }
      );

      if (response.data && response.data.success) {
        // Mark order as completed to make page read-only
        setIsOrderCompleted(true);
        notify(MESSAGES.SUCCESS, "success", 2000);
        if (response.data.messages && Array.isArray(response.data.messages) && response.data.messages.length > 0) {
          const messagesHtml = response.data.messages.map(msg => `<div>${msg}</div>`).join('');
          custom({
            title: MESSAGES.SUCCESS,
            messageHtml: messagesHtml,
            buttons: [{ text: "OK", onClick: () => { } }]
          }).show();
        }
      } else {
        // Handle error messages from successful response with Success = false
        if (response.data.messages && Array.isArray(response.data.messages) && response.data.messages.length > 0) {
          const messagesHtml = response.data.messages.map(msg => `<div>${msg}</div>`).join('');
          custom({
            title: MESSAGES.ERROR,
            messageHtml: messagesHtml,
            buttons: [{ text: "OK", onClick: () => { } }]
          }).show();
        } else {
          alert(response.data?.message || MESSAGES.FAILED_TO_COMPLETE_ORDER, MESSAGES.ERROR);
        }
      }
    } catch (error) {
      console.error("[CreateCustomerTransaction] CompleteOrder error:", error);
      console.error("[CreateCustomerTransaction] Error response data:", error.response?.data);
      
      // Extract error messages from response - prioritize Messages array
      let errorMessages = [];
      
      if (error.response && error.response.data) {
        // First, try to get Messages array (this is what the backend returns)
        if (error.response.data.messages && Array.isArray(error.response.data.messages)) {
          errorMessages = error.response.data.messages;
        } 
        // If Messages exists but is not an array, try to convert it
        else if (error.response.data.messages) {
          errorMessages = Array.isArray(error.response.data.messages) 
            ? error.response.data.messages 
            : [error.response.data.messages];
        }
        // Fallback to other message properties
        else if (error.response.data.message) {
          errorMessages = [error.response.data.message];
        } else if (typeof error.response.data === 'string') {
          errorMessages = [error.response.data];
        } else if (error.response.data.value) {
          errorMessages = [error.response.data.value];
        } else if (error.response.data.messages) {
          errorMessages = [error.response.data.messages];
        } else if (error.response.data.title) {
          errorMessages = [error.response.data.title];
        }
      }
      
      // If no messages found, use default
      if (errorMessages.length === 0) {
        errorMessages = [MESSAGES.FAILED_TO_COMPLETE_ORDER_RETRY];
      }
      
      // Display all error messages - each on a new line using HTML divs
      const messagesHtml = errorMessages.map(msg => `<div>${msg}</div>`).join('');
      custom({
        title: MESSAGES.ERROR,
        messageHtml: messagesHtml,
        buttons: [{ text: "OK", onClick: () => { } }]
      }).show();
    } finally {
      setDisable(false);
    }
  };

  const handleClicPopUpkOpen = () => {
    setaddConsigneePopup(true);
  };

  const hideConsigneePopup = () => {
    setaddConsigneePopup(false);
  };

  const handleClickOpen = () => {
    if (props.rolePermission === PermissionsConstants.TransactionReceipt) {
      dialogMessage1 = (receiptIdVar == "" ? MESSAGES.NEW_RECEIPT_CREATED : MESSAGES.RECEIPT_UPDATED);
      dialogMessage2 = (receiptIdVar == "" ? MESSAGES.RECEIPT_CREATED_CREATE_ANOTHER : MESSAGES.RECEIPT_UPDATED_CREATE_ANOTHER);
    }
    else {
      dialogMessage1 = (receiptIdVar == "" ? MESSAGES.NEW_SHIPMENT_CREATED : MESSAGES.SHIPMENT_UPDATED);
      dialogMessage2 = (receiptIdVar == "" ? MESSAGES.SHIPMENT_CREATED_CREATE_ANOTHER : MESSAGES.SHIPMENT_UPDATED_CREATE_ANOTHER);
    }

    setOpenDialogForTransaction(true);
  };

  const handleClose = () => {
    setOpenDialogForTransaction(false);

  };

  const createNewReceiptAgain = () => {
    handleClose();
    handelReset();
  };

  const disableConsigneeInput = () => {

    if (props.rolePermission === PermissionsConstants.TransactionReceipt) {
      setConsigneeInfoInputToDisable(true);
      setConsigneeIdInputToDisable(true);
      setConsigneeSearchDisable(true);
    } else {
      setConsigneeInfoInputToDisable(false);
      setConsigneeIdInputToDisable(false);
      setConsigneeSearchDisable(false);
    }
  };

  const [
    showOnlyShippersAttachedToCustomer,
    setShowOnlyShippersAttachedToCustomer,
  ] = useState(false);
  const [
    showOnlyConsigneeAttachedToCustomers,
    setshowOnlyConsigneeAttachedToCustomers,
  ] = useState(false);
  const { rolePermissions } = props.ReceiptReducer;
  const checkUserPermissions = () => {
    let consigneeAttached = false;
    let shipperAttached = false;

    if (rolePermissions) {
      if (rolePermissions[PermissionsConstants.TransactionReceipt] && Array.isArray(rolePermissions[PermissionsConstants.TransactionReceipt])) {
        for (var i = 0; i < rolePermissions[PermissionsConstants.TransactionReceipt].length; i++) {
          var perm = PermissionsConstants.TransactionReceipt + rolePermissions[PermissionsConstants.TransactionReceipt][i];

          if (perm === PermissionsConstants.TransactionReceiptViewOnlyShippersAttachedToCustomer) {
            setShowOnlyShippersAttachedToCustomer(true);
            shipperAttached = true;
          }

          if (perm === PermissionsConstants.TransactionReceiptViewOnlyConsigneeAttachedToCustomers) {
            setshowOnlyConsigneeAttachedToCustomers(true);
            consigneeAttached = true;
          }

          if (perm === PermissionsConstants.TransactionReceiptDelete) {
            setAllowedReceiptDeleteBtn(true);
          }
        }
      }

      if (rolePermissions[PermissionsConstants.TransactionShipment] && Array.isArray(rolePermissions[PermissionsConstants.TransactionShipment])) {
        for (var i = 0; i < rolePermissions[PermissionsConstants.TransactionShipment].length; i++) {
          var perm = PermissionsConstants.TransactionShipment + rolePermissions[PermissionsConstants.TransactionShipment][i];

          if (perm === PermissionsConstants.TransactionShipmentDelete) {
            setAllowedShipmentDeleteBtn(true);
            break;
          }
        }
      }
    }

    return {
      consigneeAttached: consigneeAttached,
      shipperAttached: shipperAttached,
    };
  };

  const buildDetailRequest = () => {
    let filteredPermissions = [];
    let showItemsWithZeroQuantity = false;
    let itemStatus = "";
    let showonlyActiveLots = false;
    Object.entries(rolePermissions).map(([key, values]) => {
      console.log(key);
      if (key === PermissionsConstants.TransactionReceipt) {
        values.forEach((val) => {
          filteredPermissions.push(key + val);
        });
      }
      filteredPermissions.forEach((perm) => {
        if (
          perm ===
          PermissionsConstants.TransactionReceiptViewItemsWithZeroQuantity
        ) {
          showItemsWithZeroQuantity = true;
        }

        if (
          perm === PermissionsConstants.TransactionReceiptViewOnlyActiveItems
        ) {
          itemStatus = "A";
        }

        if (
          perm === PermissionsConstants.TransactionReceiptViewOnlyActiveLots
        ) {
          showonlyActiveLots = true;
        }
      });
    });

    let builtRequest = {
      itemStatus: itemStatus,
      showItemsWithZeroQuantity: showItemsWithZeroQuantity,
      showonlyActiveLots: showonlyActiveLots
    };

    return builtRequest;
  };

  const detailDataSource = createConcurrencyAwareStore({
      onConflict: refreshGridOnConflict(detailDataGrid, changeTotals),

    key: 'key',
    loadParams:
    {
      recordType: function () {
        return "R";
      },
      itemStatus: function () {
        var request = buildDetailRequest();
        return request.itemStatus;
      },
      transactionHeaderId: function () {
        return receiptIdVar == "" ? "00000000-0000-0000-0000-000000000000" : receiptIdVar;
      },
      showItemsWithZeroQuantity: function () {
        var request = buildDetailRequest();
        return request.showItemsWithZeroQuantity;
      },
      showonlyActiveLots: function () {
        var request = buildDetailRequest();
        return request.showonlyActiveLots;
      },
      isTransItmsOnly: function () {
        return false;
      },
      mode: function () {
        return detailDataGridMode;
      },
      customerId: function () {
        return customerRowId == null || customerRowId == undefined ? "" : customerRowId;
      }
    },
    loadUrl: `${window._env_.REACT_APP_APIS}/${data.Receipt.getReceiptItems}`,
    updateUrl: `${window._env_.REACT_APP_APIS}/${data.Receipt.changeReceiptItems2}`,
    onBeforeSend: function (method, ajaxOptions) {
      ajaxOptions.headers = {
        access_token: accessToken,
        Authorization: `Bearer ${accessToken}`,
      };
    }
  });

  // Available Items DataSource - shows items available to add to order
  const availableItemsDataSource = createStore({
    key: 'key',
    loadParams:
    {
      recordType: function () {
        return "R";
      },
      itemStatus: function () {
        var request = buildDetailRequest();
        return request.itemStatus;
      },
      transactionHeaderId: function () {
        return receiptIdVar == "" ? "00000000-0000-0000-0000-000000000000" : receiptIdVar;
      },
      showItemsWithZeroQuantity: function () {
        var request = buildDetailRequest();
        return request.showItemsWithZeroQuantity;
      },
      showonlyActiveLots: function () {
        var request = buildDetailRequest();
        return request.showonlyActiveLots;
      },
      isTransItmsOnly: function () {
        return true; // Show only items not yet in transaction
      },
      mode: function () {
        return detailDataGridMode;
      },
      customerId: function () {
        return customerRowId == null || customerRowId == undefined ? "" : customerRowId;
      }
    },
    loadUrl: `${window._env_.REACT_APP_APIS}/${data.Receipt.getReceiptItems}`,
    onBeforeSend: function (method, ajaxOptions) {
      ajaxOptions.headers = {
        access_token: accessToken,
        Authorization: `Bearer ${accessToken}`,
      };
    }
  });

  // DataSource for Ordered Items - only contains selected/added items
  const orderedItemsDataSource = React.useMemo(() => {
    // Use rowid as key (primary key, always present), fallback to detailrowid if rowid doesn't exist
    const keyField = orderedItems.length > 0 && orderedItems[0].rowid ? 'rowid' : 'detailrowid';
    return new DataSource({
      store: new ArrayStore({
        data: orderedItems,
        key: keyField
      }),
      reshapeOnPush: true
    });
  }, [orderedItems]);

  // Function to fetch receipt detail items from API
  const fetchReceiptDetailItems = async () => {
    if (!receiptId || receiptId === "") {
      console.log("[CreateCustomerTransaction] No receiptId, skipping fetchReceiptDetailItems");
      return;
    }

    try {
      console.log("[CreateCustomerTransaction] Fetching receipt detail items for receiptId:", receiptId);
      const response = await axios.get(
        `${window._env_.REACT_APP_APIS}/${data.Receipt.GetReceiptDetailItems}`,
        {
          headers: {
            Key: receiptId,
            access_token: accessToken,
            Authorization: `Bearer ${accessToken}`,
          }
        }
      );

      if (response.data && Array.isArray(response.data)) {
        console.log("[CreateCustomerTransaction] Received receipt detail items:", response.data.length, "items");
        
        // Sort items by creation date (oldest first) and assign line numbers
        const sortedItems = [...response.data].sort((a, b) => {
          // Get creation date - try various field name formats
          const getCreationDate = (item) => {
            if (item.creationDate) return new Date(item.creationDate);
            if (item.CreationDate) return new Date(item.CreationDate);
            if (item.creationdatetime) return new Date(item.creationdatetime);
            if (item.Creationdatetime) return new Date(item.Creationdatetime);
            return null;
          };
          
          const dateA = getCreationDate(a);
          const dateB = getCreationDate(b);
          
          // If both have dates, sort by date (oldest first)
          if (dateA && dateB) {
            const timeDiff = dateA.getTime() - dateB.getTime();
            // If dates are equal, use LineNumber from backend as tiebreaker
            if (timeDiff === 0) {
              const lineNumA = a.LineNumber || a.lineNumber || 0;
              const lineNumB = b.LineNumber || b.lineNumber || 0;
              return lineNumA - lineNumB;
            }
            return timeDiff;
          }
          
          // If only one has a date, prioritize it
          if (dateA && !dateB) return -1;
          if (!dateA && dateB) return 1;
          
          // If no dates available, use LineNumber from backend
          const lineNumA = a.LineNumber || a.lineNumber || 0;
          const lineNumB = b.LineNumber || b.lineNumber || 0;
          
          if (lineNumA !== 0 || lineNumB !== 0) {
            return lineNumA - lineNumB;
          }
          
          // Final fallback: sort by rowid
          return a.rowid?.localeCompare(b.rowid) || 0;
        });
        
        // Assign line numbers based on sorted order (1, 2, 3, ...)
        const itemsWithLineNumbers = sortedItems.map((item, index) => ({
          ...item,
          lineNumber: index + 1
        }));
        
        console.log("[CreateCustomerTransaction] Items sorted by creation date and line numbers assigned");
        setOrderedItems(itemsWithLineNumbers);
        
        // Refresh the ordered items grid
        setTimeout(() => {
          if (detailOrderedItemsDataGrid.current && typeof detailOrderedItemsDataGrid.current.instance === 'function') {
            const instance = detailOrderedItemsDataGrid.current.instance();
            if (instance) {
              // Create new DataSource with updated items
              const newDataSource = new DataSource({
                store: new ArrayStore({
                  data: itemsWithLineNumbers,
                  key: 'key'
                })
              });
              instance.option('dataSource', newDataSource);
              instance.refresh();
              console.log("[CreateCustomerTransaction] Ordered items grid refreshed");
            }
          }
        }, 100);
      } else {
        console.log("[CreateCustomerTransaction] No items returned or invalid response format");
        setOrderedItems([]);
      }
    } catch (error) {
      console.error("[CreateCustomerTransaction] Error fetching receipt detail items:", error);
      const errorMessage = error.response?.data?.message || error.response?.data || error.message || MESSAGES.UNKNOWN_ERROR_OCCURRED;
      console.error("[CreateCustomerTransaction] Error details:", errorMessage);
    }
  };

  const onChangeReceiptQuantityUpdate = (e) => {

    if (receiptId == "") {
      alert(MESSAGES.PLEASE_SAVE_RECORD_FIRST, MESSAGES.ERROR);
      detailDataGrid.current.instance().cancelEditData();
      e.cancel = true;
    }
    else {
      if (!e.newData.hasOwnProperty('detailrowid')) {
        e.newData['detailrowid'] = e.oldData['detailrowid'];
      }

      if (!e.newData.hasOwnProperty('headerrowid')) {
        e.newData['headerrowid'] = receiptId == "" ? "00000000-0000-0000-0000-000000000000" : receiptId;
      }

      if (!e.newData.hasOwnProperty('rowid')) {
        e.newData['rowid'] = e.oldData['rowid'];
      }

      if (!e.newData.hasOwnProperty('lotid')) {
        e.newData['lotid'] = e.oldData['lotid'];
      }

      if (!e.newData.hasOwnProperty('mode')) {
        e.newData['mode'] = detailDataGridMode;
      }

      // Optimistic concurrency: the version the grid was showing. This handler copies a
      // field whitelist rather than merging all of oldData, so the token must be listed.
      if (!e.newData.hasOwnProperty('concurrencyToken')) {
        e.newData['concurrencyToken'] = e.oldData['concurrencyToken'];
      }
    }

  };

  // Store the new quantity value for use in onRowUpdated
  const orderedItemsUpdateCache = useRef({});

  // Handler for Ordered Items grid quantity update - only passes detailrowid and quantityorder
  const onChangeOrderedItemsQuantityUpdate = (e) => {
    if (receiptId == "") {
      alert(MESSAGES.PLEASE_SAVE_RECORD_FIRST, MESSAGES.ERROR);
      if (detailOrderedItemsDataGrid.current && typeof detailOrderedItemsDataGrid.current.instance === 'function') {
        detailOrderedItemsDataGrid.current.instance().cancelEditData();
      }
      e.cancel = true;
    }
    else {
      // Create minimal payload with only detailrowid, quantityorder, and headerrowid (required by backend)
      // Use detailrowid if available, otherwise use rowid (which should be the detail rowid for ordered items)
      const detailrowid = e.oldData['detailrowid'] || e.oldData['rowid'] || "00000000-0000-0000-0000-000000000000";
      const quantityorder = e.newData['quantityorder'] !== undefined ? e.newData['quantityorder'] : (e.oldData['quantityorder'] || 0);
      
      console.log("[CreateCustomerTransaction] onChangeOrderedItemsQuantityUpdate - detailrowid:", detailrowid, "old quantity:", e.oldData['quantityorder'], "new quantity:", quantityorder);
      
      // Store the new quantity value for use in onRowUpdated (since ArrayStore might not update e.data immediately)
      // Use both detailrowid and rowid as keys to ensure we can find it
      const cacheKey = detailrowid || e.oldData['rowid'];
      if (cacheKey) {
        orderedItemsUpdateCache.current[cacheKey] = {
          detailrowid: detailrowid,
          rowid: e.oldData['rowid'] || detailrowid,
          quantityorder: quantityorder,
          headerrowid: receiptId
        };
      }
      
      // Replace e.newData with only the required fields
      e.newData = {
        detailrowid: null,
        rowid: detailrowid,
        quantityorder: quantityorder,
        headerrowid: receiptId
      };
      
      console.log("[CreateCustomerTransaction] Ordered items update - detailrowid:", detailrowid, "quantityorder:", quantityorder);
    }
  };

  const onRowUpdated = async (e) => {
    console.log("[CreateCustomerTransaction] onRowUpdated called");

    // Check if this is from the ordered items grid
    const isOrderedItemsGrid = e.component && e.component.element() && 
                               e.component.element().id === "girdIdOrderedItems";

    if (isOrderedItemsGrid) {
      // For ordered items grid, we need to manually call the API since it uses ArrayStore (local-only)
      try {
        // Get the detailrowid - try both detailrowid and rowid fields
        const detailrowid = e.data.detailrowid || e.data.rowid || "00000000-0000-0000-0000-000000000000";
        const rowidForCache = e.data.rowid || detailrowid;
        
        console.log("[CreateCustomerTransaction] onRowUpdated - e.data:", e.data);
        console.log("[CreateCustomerTransaction] onRowUpdated - detailrowid:", detailrowid, "rowidForCache:", rowidForCache);
        
        // Get the new quantity from cache (set in onChangeOrderedItemsQuantityUpdate) or from e.data
        // The cache ensures we get the correct new value even if ArrayStore hasn't updated e.data yet
        // Try both detailrowid and rowid as cache keys
        const cachedUpdate = orderedItemsUpdateCache.current[detailrowid] || orderedItemsUpdateCache.current[rowidForCache];
        let quantityorder = 0;
        
        if (cachedUpdate) {
          quantityorder = cachedUpdate.quantityorder;
          console.log("[CreateCustomerTransaction] Using quantity from cache:", quantityorder, "for detailrowid:", detailrowid);
          // Clear the cache after using it
          delete orderedItemsUpdateCache.current[detailrowid];
          delete orderedItemsUpdateCache.current[rowidForCache];
        } else {
          // Fallback: try to get from e.data or get directly from grid cell
          quantityorder = e.data.quantityorder || 0;
          console.log("[CreateCustomerTransaction] Using quantity from e.data:", quantityorder, "for detailrowid:", detailrowid);
          
          // If e.data still has old value, try to get from grid cell directly
          if (detailOrderedItemsDataGrid.current && typeof detailOrderedItemsDataGrid.current.instance === 'function') {
            const gridInstance = detailOrderedItemsDataGrid.current.instance();
            const rowKey = detailrowid || rowidForCache;
            const rowIndex = gridInstance.getRowIndexByKey(rowKey);
            if (rowIndex >= 0) {
              const cellValue = gridInstance.cellValue(rowIndex, 'quantityorder');
              if (cellValue !== undefined && cellValue !== null) {
                quantityorder = cellValue;
                console.log("[CreateCustomerTransaction] Using quantity from grid cell:", quantityorder, "for detailrowid:", detailrowid);
              }
            }
          }
        }
        
        const headerrowid = receiptId;

        // Prepare the data as expected by UpdateOrderedQuantity endpoint
        // Backend expects: rowid (detail rowid), quantityorder, headerrowid
        // Backend will use Detailrowid if available, otherwise Rowid
        const itemData = {
          detailrowid: detailrowid, // Include detailrowid explicitly
          rowid: detailrowid, // Also include as rowid (backend uses Detailrowid ?? Rowid)
          quantityorder: quantityorder,
          headerrowid: headerrowid
        };
        
        console.log("[CreateCustomerTransaction] Final itemData being sent to API:", JSON.stringify(itemData));

        // Send as FormData with 'values' as JSON string (as expected by [FromForm] string values)
        const formData = new FormData();
        formData.append('values', JSON.stringify(itemData));

        console.log("[CreateCustomerTransaction] Calling UpdateOrderedQuantity for ordered items:", itemData);

        const response = await axios.put(
          `${window._env_.REACT_APP_APIS}/${data.Receipt.UpdateOrderedQuantity}`,
          formData,
          {
            headers: {
              access_token: accessToken,
              Authorization: `Bearer ${accessToken}`,
            }
          }
        );

        console.log("[CreateCustomerTransaction] UpdateOrderedQuantity response:", response.data);
        notify(MESSAGES.ORDERED_QUANTITY_UPDATE_SUCCESS, "success", 2000);
        
        // Refresh the ordered items grid with latest data from backend after successful update
        console.log("[CreateCustomerTransaction] Refreshing ordered items grid after successful update");
        await fetchReceiptDetailItems();
        changeTotals();
      } catch (error) {
        console.error("[CreateCustomerTransaction] Error updating ordered items:", error);
        
        // Extract error message from backend response
        let errorMessage = MESSAGES.FAILED_TO_UPDATE_ORDERED_QUANTITY;
        if (error.response && error.response.data) {
          // ASP.NET Core BadRequest can return the message in different formats
          // Check if it's a string directly
          if (typeof error.response.data === 'string') {
            errorMessage = error.response.data;
          } 
          // Check ProblemDetails format (value property)
          else if (error.response.data.value) {
            errorMessage = error.response.data.value;
          } 
          // Check for message property (lowercase)
          else if (error.response.data.message) {
            errorMessage = error.response.data.message;
          } 
          // Check for Message property (uppercase)
          else if (error.response.data.Message) {
            errorMessage = error.response.data.Message;
          }
          // Check for title property (ProblemDetails)
          else if (error.response.data.title) {
            errorMessage = error.response.data.title;
          }
        }
        
        alert(errorMessage, MESSAGES.ERROR);
        // Revert the change by refreshing from backend
        await fetchReceiptDetailItems();
      }
    } else {
      // Only update detail count for available items grid
      var count = detailCount;

      if (e.data.isselected) {
        count = count + 1;
      }
      else {
        count = count - 1;
      }

      setDetailCount(count);

      if (count == 0) {
        setCustomerDisabled(false);
      }
      else {
        setCustomerDisabled(true);
      }

      // Fetch receipt detail items after update to refresh ordered items grid (only for available items grid)
      console.log("[CreateCustomerTransaction] Calling fetchReceiptDetailItems after available items grid update");
      await fetchReceiptDetailItems();
    }
    changeTotals();
  };

  // Handler for Ordered Items grid row removal - shows confirmation and deletes item
  const onOrderedItemsRowRemoving = (e) => {
    // Show confirmation dialog
    e.cancel = new Promise((resolve) => {
      confirm(MESSAGES.DELETE_ORDERED_ITEM_CONFIRM, MESSAGES.DELETE_CONFIRMATION)
        .then((dialogResult) => {
          resolve(!dialogResult); // Cancel if user clicks "No"
        });
    });
  };

  // Handler for Ordered Items grid row removed - calls delete API
  const onOrderedItemsRowRemoved = async (e) => {
    console.log("[CreateCustomerTransaction] onOrderedItemsRowRemoved called", e.data);
    
    try {
      const rowId = e.data.rowid || e.data.detailrowid;
      
      if (!rowId || rowId === "00000000-0000-0000-0000-000000000000") {
        alert(MESSAGES.CANNOT_DELETE_ITEM_INVALID_ROW_ID, MESSAGES.ERROR);
        // Refresh grid to restore the row
        await fetchReceiptDetailItems();
        return;
      }

      if (!receiptId || receiptId === "") {
        alert(MESSAGES.CANNOT_DELETE_ITEM_RECEIPT_NOT_SAVED, MESSAGES.ERROR);
        // Refresh grid to restore the row
        await fetchReceiptDetailItems();
        return;
      }

      // Prepare delete request - DeleteTransactionDetails expects IEnumerable<string> rowIds
      const rowIds = [rowId]; // Array of string row IDs

      console.log("[CreateCustomerTransaction] Calling DeleteTransactionDetails with rowIds:", rowIds);

      const response = await axios.post(
        `${window._env_.REACT_APP_APIS}/${data.Transaction.DeleteTransactionDetails}`,
        rowIds,
        {
          headers: {
            access_token: accessToken,
            Authorization: `Bearer ${accessToken}`,
            'Content-Type': 'application/json'
          }
        }
      );

      console.log("[CreateCustomerTransaction] DeleteTransactionDetails response:", response.data);
      
      // Show success alert
      alert(MESSAGES.ORDERED_ITEM_DELETED_SUCCESS, MESSAGES.SUCCESS);
      
      // Refresh the ordered items grid
      await fetchReceiptDetailItems();
      changeTotals();
      
    } catch (error) {
      console.error("[CreateCustomerTransaction] Error deleting ordered item:", error);
      alert(MESSAGES.FAILED_TO_DELETE_ORDERED_ITEM, MESSAGES.ERROR);
      // Refresh grid to restore the row
      await fetchReceiptDetailItems();
    }
  };

  const onSaved = async (e) => {
    console.log("[CreateCustomerTransaction] onSaved called", e);
    
    // Check if this is from the ordered items grid
    const isOrderedItemsGrid = e.component && e.component.element() && 
                               e.component.element().id === "girdIdOrderedItems";

    // Only process WMCLEARLOTFILTER logic for available items grid
    if (!isOrderedItemsGrid && props.oidc.user.profile.hasOwnProperty("WMCLEARLOTFILTER") && props.oidc.user.profile.WMCLEARLOTFILTER == "Y") {
      // Add null checks before accessing nested properties
      if (e && e.hasOwnProperty("changes") && e.changes && e.changes.length > 0 && 
          e.changes[0] && e.changes[0].data && e.changes[0].data.quantityorder != null) {
        if (detailDataGrid.current && typeof detailDataGrid.current.instance === 'function') {
          var lotCodeColumnIndex = detailDataGrid.current.instance().getVisibleColumnIndex("lotcode");

          if (lotCodeColumnIndex >= 0) {
            var lotCodeFilterValue = detailDataGrid.current.instance().columnOption("lotcode", 'filterValue');

            if (lotCodeFilterValue != null && lotCodeFilterValue != "") {
              detailDataGrid.current.instance().columnOption("lotcode", 'filterValue', null);
              setFoucsToLotFilterTextBox = true;
            }
          }
        }
      }
    }

    // Only fetch receipt detail items for available items grid
    // For ordered items grid, onRowUpdated already handles the refresh
    if (!isOrderedItemsGrid) {
      // Fetch receipt detail items after all changes are saved (only for available items grid)
      console.log("[CreateCustomerTransaction] Calling fetchReceiptDetailItems after save (available items grid)");
      await fetchReceiptDetailItems();
    } else {
      console.log("[CreateCustomerTransaction] Skipping fetchReceiptDetailItems in onSaved for ordered items grid (handled by onRowUpdated)");
    }
    changeTotals();
  };

  const onContentReady = (e) => {
    // Ensure dataSource is set when grid is ready
    if (detailDataGrid.current && typeof detailDataGrid.current.instance === 'function') {
      const instance = detailDataGrid.current.instance();
      if (instance) {
        if (!instance.option('dataSource')) {
          instance.option('dataSource', detailDataSource);
        }
      }
    }

    if (setFoucsToLotFilterTextBox == true) {
      if (detailDataGrid.current && typeof detailDataGrid.current.instance === 'function') {
        var lotCodeColumnIndex = detailDataGrid.current.instance().getVisibleColumnIndex("lotcode");

        if (lotCodeColumnIndex >= 0) {
          var editorElement = document.querySelector("#wmCreateReceiptDetailDataGrid tr.dx-row.dx-datagrid-filter-row > td:nth-child(" + (lotCodeColumnIndex + 1) + ") input");
          if (editorElement != null) {
            setTimeout(() => editorElement.focus(), 500);
          }
        }
        setFoucsToLotFilterTextBox = false;
      }
    }

  };

  // Handler for Available Items grid selection
  const onAvailableItemsSelectionChanged = (e) => {
    const selectedRowsData = e.selectedRowsData;
    if (selectedRowsData && selectedRowsData.length > 0) {
      setSelectedAvailableItem(selectedRowsData[0]);
      setAddToOrderButtonDisabled(false);
    } else {
      setSelectedAvailableItem(null);
      setAddToOrderButtonDisabled(true);
    }
  };

  // Handler for Add to Order button
  const handleAddToOrder = async () => {
    if (!selectedAvailableItem || !receiptId) {
      alert(MESSAGES.PLEASE_SELECT_ITEM_AND_SAVE_RECEIPT, MESSAGES.ERROR);
      return;
    }

    try {
      // Prepare the data to add to ordered items
      const itemData = {
        ...selectedAvailableItem,
        headerrowid: receiptId,
        quantityorder: selectedAvailableItem.quantityorder || 0,
        isselected: false,
        mode: detailDataGridMode
      };

      // Call API to add item to receipt
      const response = await axios.post(
        `${window._env_.REACT_APP_APIS}/${data.Receipt.changeReceiptItems2}`,
        itemData,
        {
          headers: {
            access_token: accessToken,
            Authorization: `Bearer ${accessToken}`,
          }
        }
      );

      // Refresh both grids
      if (detailDataGrid.current && typeof detailDataGrid.current.instance === 'function') {
        detailDataGrid.current.instance().refresh();
      }
      if (availableItemsGridRef.current && typeof availableItemsGridRef.current.instance === 'function') {
        availableItemsGridRef.current.instance().refresh();
      }

      // Clear selection
      if (availableItemsGridRef.current && typeof availableItemsGridRef.current.instance === 'function') {
        availableItemsGridRef.current.instance().clearSelection();
      }
      setSelectedAvailableItem(null);
      setAddToOrderButtonDisabled(true);

      notify(MESSAGES.ITEM_ADDED_TO_ORDER_SUCCESS, "success", 2000);
    } catch (error) {
      console.error("Error adding item to order:", error);
      alert(MESSAGES.FAILED_TO_ADD_ITEM_TO_ORDER, MESSAGES.ERROR);
    }
  };

  // Handler for Ordered Items grid selection
  const onOrderedItemsSelectionChanged = (e) => {
    const selectedRowsData = e.selectedRowsData;
    if (selectedRowsData && selectedRowsData.length > 0) {
      setSelectedOrderedItem(selectedRowsData[0]);
      setRemoveFromOrderButtonDisabled(false);
      setAddToOrderButtonDisabled(false);
    } else {
      setSelectedOrderedItem(null);
      setRemoveFromOrderButtonDisabled(true);
      setAddToOrderButtonDisabled(true);
    }
  };

  // Handler for Add to Order button
  const handleAddToOrderClick = async () => {
    if (!selectedAvailableItem || !receiptId) {
      alert(MESSAGES.PLEASE_SELECT_ITEM_AND_SAVE_RECEIPT, MESSAGES.ERROR);
      return;
    }

    try {
      // Prepare the data to add to ordered items - ensure all required fields are present
      // For new items, detailrowid should be empty GUID since it doesn't exist yet
      const itemData = {
        ...selectedAvailableItem,
        headerrowid: receiptId,
        detailrowid: "00000000-0000-0000-0000-000000000000", // Empty GUID for new items
        rowid: selectedAvailableItem.rowid || selectedAvailableItem.key || "",
        lotid: selectedAvailableItem.lotid || "",
        quantityorder: selectedAvailableItem.quantityorder || 1,
        isselected: false,
        mode: detailDataGridMode
      };

      // Call API to insert item to receipt - endpoint expects [FromForm] with "values" as JSON string
      const formData = new FormData();
      formData.append('values', JSON.stringify(itemData)); // API expects "values" as a JSON string
      
      const response = await axios.post(
        `${window._env_.REACT_APP_APIS}/${data.Receipt.InsertReceiptDetailItems}`,
        formData,
        {
          headers: {
            access_token: accessToken,
            Authorization: `Bearer ${accessToken}`,
            // Don't set Content-Type - let browser set it with boundary for FormData
          }
        }
      );

      // Add the item to orderedItems array (only selected items)
      setOrderedItems(prevItems => {
        // Check if item already exists (by key or by itemcode+lotcode combination)
        const itemKey = selectedAvailableItem.key || `${selectedAvailableItem.itemcode}_${selectedAvailableItem.lotcode || ''}_${Date.now()}`;
        const existingIndex = prevItems.findIndex(item => 
          item.key === selectedAvailableItem.key || 
          (item.itemcode === selectedAvailableItem.itemcode && item.lotcode === selectedAvailableItem.lotcode)
        );
        if (existingIndex >= 0) {
          // Update existing item
          const updatedItems = [...prevItems];
          updatedItems[existingIndex] = { ...itemData, key: itemKey };
          return updatedItems;
        } else {
          // Add new item
          return [...prevItems, { ...itemData, key: itemKey }];
        }
      });

      // Refresh Available Items grid
      if (detailDataGrid.current && typeof detailDataGrid.current.instance === 'function') {
        detailDataGrid.current.instance().refresh();
      }

      // Reload Ordered Items grid dataSource
      if (detailOrderedItemsDataGrid.current && typeof detailOrderedItemsDataGrid.current.instance === 'function') {
        const instance = detailOrderedItemsDataGrid.current.instance();
        instance.option('dataSource', orderedItemsDataSource);
        instance.refresh();
      }

      // Clear selection
      if (detailDataGrid.current && typeof detailDataGrid.current.instance === 'function') {
        detailDataGrid.current.instance().clearSelection();
      }
      setSelectedAvailableItem(null);
      setAddToOrderButtonDisabled(true);

      notify(MESSAGES.ITEM_ADDED_TO_ORDER_SUCCESS, "success", 2000);
    } catch (error) {
      console.error("Error adding item to order:", error);
      const errorMessage = error.response?.data?.message || error.response?.data || error.message || MESSAGES.UNKNOWN_ERROR_OCCURRED;
      alert(`${MESSAGES.FAILED_TO_ADD_ITEM_TO_ORDER}: ${JSON.stringify(errorMessage)}`, MESSAGES.ERROR);
    }
  };

  // Handler for Remove from Order button (moves item back to Available Items)
  const handleRemoveFromOrder = async () => {
    if (!selectedOrderedItem || !receiptId) {
      alert(MESSAGES.PLEASE_SELECT_ITEM_AND_SAVE_RECEIPT, MESSAGES.ERROR);
      return;
    }

    try {
      // Set quantity to 0 or remove the item from the receipt
      const itemData = {
        ...selectedOrderedItem,
        headerrowid: receiptId,
        quantityorder: 0, // Set quantity to 0 to effectively remove it
        isselected: false,
        mode: detailDataGridMode
      };

      // Call API to update item (set quantity to 0)
      const response = await axios.post(
        `${window._env_.REACT_APP_APIS}/${data.Receipt.changeReceiptItems2}`,
        itemData,
        {
          headers: {
            access_token: accessToken,
            Authorization: `Bearer ${accessToken}`,
          }
        }
      );

      // Refresh Available Items grid
      if (detailDataGrid.current && typeof detailDataGrid.current.instance === 'function') {
        detailDataGrid.current.instance().refresh();
      }

      // Reload Ordered Items grid dataSource
      if (detailOrderedItemsDataGrid.current && typeof detailOrderedItemsDataGrid.current.instance === 'function') {
        const instance = detailOrderedItemsDataGrid.current.instance();
        instance.option('dataSource', orderedItemsDataSource);
        instance.refresh();
      }

      // Clear selection
      if (detailDataGrid.current && typeof detailDataGrid.current.instance === 'function') {
        detailDataGrid.current.instance().clearSelection();
      }
      setSelectedOrderedItem(null);
      setRemoveFromOrderButtonDisabled(true);

      notify(MESSAGES.ITEM_REMOVED_FROM_ORDER_SUCCESS, "success", 2000);
      changeTotals();
    } catch (error) {
      console.error("Error removing item from order:", error);
      alert(MESSAGES.FAILED_TO_REMOVE_ITEM_FROM_ORDER, MESSAGES.ERROR);
    }
  };

  useEffect(() => {
    receiptIdVar = "";
    setHeaderId(receiptIdVar);
    dialogMessage1 = "";
    dialogMessage2 = "";

    if (props.oidc.user.profile.hasOwnProperty("WMDETAILDATAGRIDMODE")) {
      detailDataGridMode = props.oidc.user.profile.WMDETAILDATAGRIDMODE;
      setSelectedValue(props.oidc.user.profile.WMDETAILDATAGRIDMODE);
    }

    setIsDisabled(disableTransDate(props.oidc.user.profile.LOGINTYPEID));
    checkUserPermissions();
    loadShipperAutoComponentData();
    loadCarrierAutoComponentData();
    loadProfileAutoComponentData();
    loadCustomerAutoComponentData();
    loadConsigneeAutoComponentData();
    disableConsigneeInput();
    if (!props.oidc.user.profile.hasOwnProperty("LOGINTYPEID") || props.oidc.user.profile.LOGINTYPEID != ABECASUSER_LOGIN_TYPE) {
      loadTransactionFromProfile("");
    }
  }, []);

  // Refresh DataGrid when receiptId changes or when Details tab is selected
  useEffect(() => {
    if (receiptId && selectedBottomTabIndex === 1) {
      // Only refresh if Details tab is selected
      setTimeout(() => {
        if (detailDataGrid.current && typeof detailDataGrid.current.instance === 'function') {
          const instance = detailDataGrid.current.instance();
          if (instance) {
            instance.option("dataSource", detailDataSource);
            instance.refresh();
          }
        }
        // Also refresh available items grid
        if (availableItemsGridRef.current && typeof availableItemsGridRef.current.instance === 'function') {
          const instance = availableItemsGridRef.current.instance();
          if (instance) {
            instance.option("dataSource", availableItemsDataSource);
            instance.refresh();
          }
        }
      }, 200);
    }
  }, [receiptId, selectedBottomTabIndex]);

  // Apply min-height to TabPanel container for Create Receipt page
  useEffect(() => {
    const applyTabPanelHeight = () => {
      const tabPanelElement = document.getElementById('create-receipt-tabpanel');
      if (tabPanelElement) {
        const container = tabPanelElement.querySelector('.dx-tabpanel-container');
        if (container) {
          container.style.minHeight = '78vh';
        }
      }
    };

    // Apply immediately and with delays to ensure DOM is ready
    applyTabPanelHeight();
    const timeout1 = setTimeout(applyTabPanelHeight, 100);
    const timeout2 = setTimeout(applyTabPanelHeight, 500);

    return () => {
      clearTimeout(timeout1);
      clearTimeout(timeout2);
    };
  }, [selectedBottomTabIndex]);

  const onUpdateTransaction = () => {
    setSelectedBottomTabIndex(1);
    /*
    if (props.rolePermission === PermissionsConstants.TransactionReceipt) {
      history.push("/wm/transaction/change-receipt");
    } else {
      history.push("/wm/transaction/change-shippment");
    }*/
    handleClose();

  };

  const [lookupDataList, setLookupDataList] = useState([]);
  const [openLookupForm, setOpenLookupForm] = useState(false);

  let [lookupSearchRequest, setLookupSearchRequest] = useState({
    identityIdFrom: "",
    identityIdTo: "",
    name: "",
    lookupType: 0,
    showOnlyConsigneeAttachedToCustomers: showOnlyConsigneeAttachedToCustomers,
    showOnlyShippersAttachedToCustomer: showOnlyShippersAttachedToCustomer,
  });

  const getAllLookupsData = () => {
    axios
      .post(
        `${window._env_.REACT_APP_APIS}/${data.Receipt.SearchLookup}`,
        lookupSearchRequest,
        {
          headers: {
            "Content-Type": "application/json",
            access_token: accessToken,
          },
        }
      )
      .then((res) => {
        console.log(res, "res");
        setLookupDataList(res.data.lookups);
      })
      .catch((err) => {
        console.log(err, "err in loading lookups data");
      });
  };
  let [lookupFormName, setLookupFormName] = useState("");
  const openSearchIdsForm = (lookupType) => {
    lookupSearchRequest = {
      identityIdFrom:
        lookupType === consigneeLookup
          ? consigneeData != null && consigneeData.identityId != null
            ? consigneeData.identityId
            : ""
          : lookupType === shipperLookup
            ? shipperData != null && shipperData.identityId != null
              ? shipperData.identityId
              : ""
            : lookupType === carrierLookup
              ? carrierData != null && carrierData.identityId != null
                ? carrierData.identityId
                : ""
              : customerData != null && customerData.identityId != null
                ? customerData.identityId
                : "",
      identityIdTo: "",
      name: "",
      lookupType: lookupType,
      showOnlyConsigneeAttachedToCustomers: showOnlyConsigneeAttachedToCustomers,
      showOnlyShippersAttachedToCustomer: showOnlyShippersAttachedToCustomer,
    };

    setLookupSearchRequest({
      ...lookupSearchRequest,
      identityIdFrom:
        lookupType === consigneeLookup
          ? consigneeData != null && consigneeData.identityId != null
            ? consigneeData.identityId
            : ""
          : lookupType === shipperLookup
            ? shipperData != null && shipperData.identityId != null
              ? shipperData.identityId
              : ""
            : lookupType === carrierLookup
              ? carrierData != null && carrierData.identityId != null
                ? carrierData.identityId
                : ""
              : customerData != null && customerData.identityId != null
                ? customerData.identityId
                : "",
    });

    setLookupFormName(
      lookupType === consigneeLookup ? "Consignee" : lookupType === shipperLookup ? "Shipper" : lookupType === carrierLookup ? "Carrier" : "Customer"
    );
    setOpenLookupForm(true);
    getAllLookupsData();
  };
  const closeLookupSearchForm = () => {
    setOpenLookupForm(false);
    setLookupSearchRequest({
      identityIdFrom: "",
      identityIdTo: "",
      name: "",
      lookupType: 0,
      showOnlyConsigneeAttachedToCustomers:
        showOnlyConsigneeAttachedToCustomers,
      showOnlyShippersAttachedToCustomer: showOnlyShippersAttachedToCustomer,
    });
  };

  const { identityIdFrom, identityIdTo, name } = lookupSearchRequest;
  const onLookupFieldChange = (e) => {

    if (e.event) {
      const name = e.event.target.name; // Get the name of the TextBox
      const value = e.value; // Get the new value
      setLookupSearchRequest({
        ...lookupSearchRequest,
        [name]: value,
      });
    }
  };
  const resetLookupForm = () => {
    lookupSearchRequest = {
      identityIdFrom: "",
      identityIdTo: "",
      name: "",
      lookupType:
        lookupFormName === "Consignee"
          ? 0
          : lookupFormName === "Shipper"
            ? 1
            : lookupFormName === "Carrier"
              ? carrierLookup : customerLookup,
      showOnlyConsigneeAttachedToCustomers:
        showOnlyConsigneeAttachedToCustomers,
      showOnlyShippersAttachedToCustomer: showOnlyShippersAttachedToCustomer,
    };

    setLookupSearchRequest({
      identityIdFrom: "",
      identityIdTo: "",
      name: "",
      lookupType:
        lookupFormName === "Consignee"
          ? 0
          : lookupFormName === "Shipper"
            ? 1
            : lookupFormName === "Carrier"
              ? carrierLookup : customerLookup,
      showOnlyConsigneeAttachedToCustomers:
        showOnlyConsigneeAttachedToCustomers,
      showOnlyShippersAttachedToCustomer: showOnlyShippersAttachedToCustomer,
    });

    //dataGrid.current.instance().deselectAll();

    getAllLookupsData();
  };
  const onSearchLookupIds = () => {
    getAllLookupsData();
  };
  const onSelectionChanged = ({ selectedRowsData }) => {

    const lengthArray = selectedRowsData.length;
    let selectedLookupData = selectedRowsData[lengthArray - 1];

    let arr = [];
    arr.push(selectedLookupData);
    if (lookupFormName === "Consignee") {
      setTransaction({
        ...transaction,
        rConsignee: selectedLookupData == null ? "" : selectedLookupData.rowid,
        consigneeVal: selectedLookupData == null ? "" : selectedLookupData.name,
      });

      setConsigneeData(selectedLookupData);
      setGuidForConsignee(selectedRowsData);
      setConsigneeInfo(getConsigneeInfo(selectedLookupData));
    } else if (lookupFormName === "Shipper") {
      setTransaction({
        ...transaction,
        rShipper: selectedLookupData == null ? "" : selectedLookupData.rowid,
        shipperVal: selectedLookupData == null ? "" : selectedLookupData.name,
      });

      setshipperData(selectedLookupData);
      setGuidForShipper(selectedRowsData);

    } else if (lookupFormName === "Carrier") {
      setTransaction({
        ...transaction,
        rCarrier: selectedLookupData == null ? "" : selectedLookupData.rowid,
        carrierVal: selectedLookupData == null ? "" : selectedLookupData.name,
      });

      setCarrierData(selectedLookupData);
      setGuidForCarrier(selectedRowsData);
    }
    else {
      setTransaction({
        ...transaction,
        rCustomer: selectedLookupData == null ? "" : selectedLookupData.rowid,
        customerVal: selectedLookupData == null ? "" : selectedLookupData.name,
      });

      setCustomerData(selectedLookupData);
      setGuidForCustomer(selectedRowsData);
      customerRowId = selectedLookupData?.rowid;
      if (detailDataGrid.current?.instance()) {
        detailDataGrid.current.instance().refresh();
      }
    }
  };



  const [profileLookupDataList, setProfileLookupDataList] = useState([]);
  const [openProfileLookupForm, setOpenProfileLookupForm] = useState(false);
  let [profileLookupSearchRequest, setProfileLookupSearchRequest] = useState({
    code: "",
    description: ""
  });

  const getAllProfileLookupsData = () => {
    axios
      .post(
        `${window._env_.REACT_APP_APIS}/${data.Receipt.SearchProfileLookup}`,
        profileLookupSearchRequest,
        {
          headers: {
            "Content-Type": "application/json",
            access_token: accessToken,
          },
        }
      )
      .then((res) => {
        console.log(res, "res");
        setProfileLookupDataList(res.data.lookups);
      })
      .catch((err) => {
        console.log(err, "err in loading lookups data");
      });
  };
  const openProfileSearchIdsForm = () => {
    profileLookupSearchRequest = {
      code: profileData != null && profileData.code != null ? profileData.code : "",
      description: ""
    };

    setProfileLookupSearchRequest({
      ...profileLookupSearchRequest,
      code: profileData != null && profileData.code != null ? profileData.code : ""
    });

    setOpenProfileLookupForm(true);
    getAllProfileLookupsData();
  };

  const closeProfileLookupSearchForm = () => {
    setOpenProfileLookupForm(false);
    setProfileLookupSearchRequest({
      code: "",
      description: ""
    });
  };

  const { code, description } = profileLookupSearchRequest;
  const onProfileLookupFieldChange = (e) => {

    if (e.event) {
      setProfileLookupSearchRequest({
        ...profileLookupSearchRequest,
        [e.target.name]: e.target.value,
      });
    }
  };
  const resetProfileLookupForm = () => {
    profileLookupSearchRequest = {
      code: "",
      description: ""
    };

    setProfileLookupSearchRequest({
      code: "",
      description: ""
    });

    profileDataGrid.current.instance().deselectAll();
    getAllProfileLookupsData();
  };

  const onSearchProfileLookupIds = () => {
    getAllProfileLookupsData();
  };
  const onProfileSelectionChanged = ({ selectedRowsData }) => {
    let selectedLookupData = selectedRowsData[0];

    let arr = [];
    arr.push(selectedLookupData);
    setTransaction({
      ...transaction,
      rProfile: selectedLookupData == null ? "" : selectedLookupData.rowid,
      profileVal: selectedLookupData == null ? "" : selectedLookupData.code,
    });


    setProfileData(selectedLookupData);
    setGuidForProfile(selectedRowsData);
    loadTransactionFromProfile(selectedLookupData?.rowid);

  };





  const handleSearchForConsignee = (e) => {
    var permissions = checkUserPermissions();
    let key = e.target.value;
    const lookup = 0;
    let request = {
      identityIdFrom: key,
      lookupType: lookup,
      isAutoComplete: true,
      showOnlyConsigneeAttachedToCustomers: permissions.consigneeAttached,
      showOnlyShippersAttachedToCustomer: permissions.shipperAttached,
    };
    axios
      .post(
        `${window._env_.REACT_APP_APIS}/${data.Receipt.SearchLookup}`,
        request,
        {
          headers: {
            "Content-Type": "application/json",
            access_token: accessToken,
            Authorization: `Bearer ${accessToken}`,
          },
        }
      )
      .then((resp) => {
        setGuidForConsignee(resp.data.lookups);
        /*
        setConsigneeData(
          resp.data.lookups.length > 0 ? resp.data.lookups[0] : {}
        );
        setConsigneeInfo(
          getConsigneeInfo(
            resp.data.lookups.length > 0 ? resp.data.lookups[0] : {}
          )
        );
        */
      });
  };
  const debouncedChangeHandlerForConsignee = useCallback(
    debounce(handleSearchForConsignee, 600),
    []
  );
  const handleSearchForShipper = (e) => {
    var permissions = checkUserPermissions();
    let key = e.target.value;
    const lookup = 1;
    let request = {
      identityIdFrom: key,
      lookupType: lookup,
      isAutoComplete: true,
      showOnlyConsigneeAttachedToCustomers: permissions.consigneeAttached,
      showOnlyShippersAttachedToCustomer: permissions.shipperAttached,
    };
    axios
      .post(
        `${window._env_.REACT_APP_APIS}/${data.Receipt.SearchLookup}`,
        request,
        {
          headers: {
            "Content-Type": "application/json",
            access_token: accessToken,
            Authorization: `Bearer ${accessToken}`,
          },
        }
      )
      .then((resp) => {
        setGuidForShipper(resp.data.lookups);
        /*
        setshipperData(
          resp.data.lookups.length > 0 ? resp.data.lookups[0] : {}
        );
        */
      });
  };
  const debouncedForShipper = useCallback(
    debounce(handleSearchForShipper, 800),
    []
  );

  const onItemClick = (e) => {
    setTransaction({ ...transaction, freightChargeType: e.value });
  }

  const handleSearchForCarrier = (e) => {
    let key = e.target.value;
    const lookup = 2;
    let request = {
      identityIdFrom: key,
      lookupType: lookup,
      isAutoComplete: true,
    };
    axios
      .post(
        `${window._env_.REACT_APP_APIS}/${data.Receipt.SearchLookup}`,
        request,
        {
          headers: {
            "Content-Type": "application/json",
            access_token: accessToken,
            Authorization: `Bearer ${accessToken}`,
          },
        }
      )
      .then((resp) => {
        setGuidForCarrier(resp.data.lookups);
        /*
        setCarrierData(
          resp.data.lookups.length > 0 ? resp.data.lookups[0] : {}
        );
        */
      });
  };

  const debouncedForCarrier = useCallback(
    debounce(handleSearchForCarrier, 800),
    []
  );

  const handleSearchForCustomer = (e) => {
    let key = e.target.value;
    const lookup = 3;
    let request = {
      identityIdFrom: key,
      lookupType: lookup,
      isAutoComplete: true,
    };
    axios
      .post(
        `${window._env_.REACT_APP_APIS}/${data.Receipt.SearchLookup}`,
        request,
        {
          headers: {
            "Content-Type": "application/json",
            access_token: accessToken,
            Authorization: `Bearer ${accessToken}`,
          },
        }
      )
      .then((resp) => {
        setGuidForCustomer(resp.data.lookups);
      });
  };

  const debouncedForCustomer = useCallback(
    debounce(handleSearchForCustomer, 800),
    []
  );

  const handleSearchForProfile = (e) => {
    let key = e.target.value;
    let request = {
      code: key,
      isAutoComplete: true
    };
    axios
      .post(
        `${window._env_.REACT_APP_APIS}/${data.Receipt.SearchProfileLookup}`,
        request,
        {
          headers: {
            "Content-Type": "application/json",
            access_token: accessToken,
            Authorization: `Bearer ${accessToken}`,
          },
        }
      )
      .then((resp) => {
        setGuidForProfile(resp.data.lookups);
      });
  };

  const debouncedForProfile = useCallback(
    debounce(handleSearchForProfile, 800),
    []
  );

  const renderConsigneeSearchButton = (disableConsigneeSearch) => {
    if (disableConsigneeSearch) {
      return (

        <Button
          icon="search"

          stylingMode="text"

        />

      );
    } else {
      return (
        /*        <span
                 style={{
                   cursor: "pointer",
                   padding: "5px 2px"
                 }}
               >
                 <SearchIcon onClick={() => openSearchIdsForm(0)} />
               </span> */
        <Button
          icon="search"
          onClick={() => openSearchIdsForm(0)}
          stylingMode="text"

        />

      );
    }
  };
  const backToMainGrid = () => {
    let itemArray = [];
    dispatch(Reset_Items(itemArray));
    props.resetQueryForm(null);
    props.transactionCallbackOnUnCheck(0);
    history.push("/wm/transaction");
  };
  const getConsigneeInfo = (data) => {
    let consigneeInfo = "";
    if (data != undefined) {
      consigneeInfo = "Name: ";
      if (data.name !== undefined && data?.name !== null && data?.name !== "") {
        consigneeInfo += data.name.trim();
      }

      consigneeInfo += "\r\nAddress: ";

      if (data.address1 !== undefined && data?.address1 !== null && data?.address1 !== "") {
        consigneeInfo += data.address1.trim();
        consigneeInfo += "\r\n";

      }

      if (data.address2 !== undefined && data?.address2 !== null && data?.address2 !== "") {
        consigneeInfo += data.address2.trim();
        consigneeInfo += "\r\n";

      }
      if (data.city !== undefined && data?.city !== null && data?.city !== "") {
        consigneeInfo += data.city.trim() + " ";
      }

      if (data.state !== undefined && data?.state !== null && data?.state !== "") {
        consigneeInfo += data.state.trim() + " ";
      }

      if (data.zip !== undefined && data?.zip !== null && data?.zip !== "") {
        consigneeInfo += data.zip.trim();
      }
      consigneeInfo += "\r\n";
      if (data.country !== undefined && data?.country !== null && data?.country !== "") {
        consigneeInfo += data.country.trim();
      }
    }

    return consigneeInfo;

    /*
    if (
      data != undefined &&
      data.name !== undefined &&
      data.address1 !== undefined
    )
      return (
        "Name: " +
        (data?.name == null ? "" : data?.name) +
        "\n" +
        "Address: " +
        (data?.address1 == null ? "" : data?.address1)
      );
    return "";
    */
  };
  const [currentLayout, setCurrentLayout] = useState("Default");

  const gridKey = "2823812B-ABA9-4266-99DD-D6134745E8D2";
  const loadState = useCallback(() => { return GridLayout.sendStorageRequest(gridKey, "GET", accessToken, null, currentLayout); }, [currentLayout]);
  const saveState = useCallback((state) => { GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, currentLayout); }, [gridKey, currentLayout]);
  //////////Shipper AutoComponent///////////////////////
  const shipperRef = useRef({});
  const [dateSourceSupplier, setDateSourceSupplier] = useState(null);
  const handleShipperChange = useCallback((e) => {

    console.log(e);
    setshipperData(e.value);
  }, []);
  const loadShipperAutoComponentData = useCallback(() => {
    var permissions = checkUserPermissions();
    var dataSourceDB = new DataSource({
      store: new createStore({
        key: 'rowid',
        loadParams: {
          consigneeAttached: function () {
            return permissions.consigneeAttached;
          },
          shipperAttached: function () {
            return permissions.shipperAttached;
          }
        },
        loadUrl: `${window._env_.REACT_APP_APIS}/wm/Transaction/GetShipperLookupPaging`,
        onBeforeSend: function (method, ajaxOptions) {
          ajaxOptions.headers = {
            Authorization: `Bearer ${accessToken}`
          };
        }
      }),
      paginate: true,
      pageSize: 100
    });
    setDateSourceSupplier(dataSourceDB);
  }, []);

  const ApplyFilterForShipperAutoComponent = (identityId) => {
    var permissions = checkUserPermissions();
    const dataSourceDB = new DataSource({
      store: new createStore({
        key: 'rowid',
        loadParams: {
          consigneeAttached: function () {
            return permissions.consigneeAttached;
          },
          shipperAttached: function () {
            return permissions.shipperAttached;
          }
        },
        loadUrl: `${window._env_.REACT_APP_APIS}/wm/Transaction/GetShipperLookupPaging`,
        onBeforeSend: (method, ajaxOptions) => {
          ajaxOptions.headers = {
            Authorization: `Bearer ${accessToken}`
          };
        },
      }),
      filter: ['identityId', '=', identityId],
      paginate: true,
      pageSize: 100,
    });
    setDateSourceSupplier(dataSourceDB);
  }
  //////////Shipper AutoComponent///////////////////////
  //////////Carrier AutoComponent///////////////////////
  const carrierRef = useRef({});
  const handleCarrierChange = useCallback((e) => {

    console.log(e);
    setCarrierData(e.value);
  }, []);
  const loadCarrierAutoComponentData = useCallback(() => {
    var permissions = checkUserPermissions();
    var shipperDataSource = new DataSource({
      store: new createStore({
        key: 'rowid',
        loadParams: {
          consigneeAttached: function () {
            return permissions.consigneeAttached;
          },
          shipperAttached: function () {
            return permissions.shipperAttached;
          }
        },
        loadUrl: `${window._env_.REACT_APP_APIS}/wm/Transaction/GetCarrierLookupPaging`,
        onBeforeSend: function (method, ajaxOptions) {
          ajaxOptions.headers = {
            Authorization: `Bearer ${accessToken}`
          };
        }
      }),
      paginate: true,
      pageSize: 100
    });
    setDataSource(shipperDataSource);
    // if (carrierRef.current.instance) {
    //   carrierRef.current.instance().option('dataSource', shipperDataSource);
    // }

  }, []);

  const ApplyFilterForCarrierAutoComponent = (identityId) => {
    var permissions = checkUserPermissions();
    const shipperDataSource = new DataSource({
      store: new createStore({
        key: 'rowid',
        loadParams: {
          consigneeAttached: function () {
            return permissions.consigneeAttached;
          },
          shipperAttached: function () {
            return permissions.shipperAttached;
          }
        },
        loadUrl: `${window._env_.REACT_APP_APIS}/wm/Transaction/GetCarrierLookupPaging`,
        onBeforeSend: (method, ajaxOptions) => {
          ajaxOptions.headers = {
            Authorization: `Bearer ${accessToken}`
          };
        },
      }),
      filter: ['identityId', '=', identityId],
      paginate: true,
      pageSize: 100,
    });
    setDataSource(shipperDataSource);
  }
  //////////Carrier AutoComponent///////////////////////
  //////////Profile AutoComponent///////////////////////
  const [dateSourceProfile, setDateSourceProfile] = useState(null);
  let profileDataState = "";
  const handleProfileChange = (e) => {

    console.log(e);
    if (e.event) {
      const newValue = e.value;
      if (profileDataState !== e.value.rowid) {
        profileDataState = e.value?.rowid;
        setProfileData(e.value);
        loadTransactionFromProfile(newValue?.rowid);
      };
    }
  };


  const loadProfileAutoComponentData = useCallback(() => {
    var permissions = checkUserPermissions();
    var dataSourceDb = new DataSource({
      store: new createStore({
        key: 'rowid',
        loadParams: {
          consigneeAttached: function () {
            return permissions.consigneeAttached;
          },
          shipperAttached: function () {
            return permissions.shipperAttached;
          }
        },
        loadUrl: `${window._env_.REACT_APP_APIS}/wm/Transaction/GetProfileLookupPaging`,
        onBeforeSend: function (method, ajaxOptions) {
          ajaxOptions.headers = {
            Authorization: `Bearer ${accessToken}`
          };
        }
      }),
      paginate: true,
      pageSize: 100
    });

    setDateSourceProfile(dataSourceDb);
  }, []);

  const selectionChanged = useCallback(
    (e, tg) => {
      let newItems = [...selectedItems];
      e.removedItems.forEach((item) => {
        const index = newItems.indexOf(item);
        if (index >= 0) {
          newItems.splice(index, 1);
        }
      });
      if (e.addedItems.length) {
        newItems = [...newItems, ...e.addedItems];
      }
      setSelectedItems(newItems);
      setSearchPanelStatus((prevStatus) => {
        const newStatus = !prevStatus;
        return newStatus;
      });
    },
    [selectedItems, setSelectedItems],
  );
  const ApplyFilterForProfileAutoComponent = (identityId) => {
    var permissions = checkUserPermissions();
    const dataSourceDb = new DataSource({
      store: new createStore({
        key: 'rowid',
        loadParams: {
          consigneeAttached: function () {
            return permissions.consigneeAttached;
          },
          shipperAttached: function () {
            return permissions.shipperAttached;
          }
        },
        loadUrl: `${window._env_.REACT_APP_APIS}/wm/Transaction/GetProfileLookupPaging`,
        onBeforeSend: (method, ajaxOptions) => {
          ajaxOptions.headers = {
            Authorization: `Bearer ${accessToken}`,
          };
        },
      }),
      filter: ['identityId', '=', identityId],
      paginate: true,
      pageSize: 100,
    });

    setDateSourceProfile(dataSourceDb);
  }
  //////////Profile AutoComponent///////////////////////  
  //////////Customer AutoComponent///////////////////////
  const CustomerRef = useRef({});
  const [dateSourceCustomer, setDateSourceCustomer] = useState(null);
  const handleCustomerChange = useCallback((e) => {

    console.log(e);
    setCustomerData(e.value);
    customerRowId = e.value?.rowid;
    if (detailDataGrid.current?.instance()) {
      detailDataGrid.current.instance().refresh();
    }
  }, []);
  const loadCustomerAutoComponentData = useCallback(() => {
    var permissions = checkUserPermissions();
    var dataSourceDB = new DataSource({
      store: new createStore({
        key: 'rowid',
        loadParams: {
          consigneeAttached: function () {
            return permissions.consigneeAttached;
          },
          shipperAttached: function () {
            return permissions.shipperAttached;
          }
        },
        loadUrl: `${window._env_.REACT_APP_APIS}/wm/Transaction/GetCustomerLookupPaging`,
        onBeforeSend: function (method, ajaxOptions) {
          ajaxOptions.headers = {
            Authorization: `Bearer ${accessToken}`
          };
        }
      }),
      paginate: true,
      pageSize: 100
    });
    setDateSourceCustomer(dataSourceDB);
  }, []);

  const ApplyFilterForCustomerAutoComponent = (identityId) => {
    var permissions = checkUserPermissions();
    const dataSourceDB = new DataSource({
      store: new createStore({
        key: 'rowid',
        loadParams: {
          consigneeAttached: function () {
            return permissions.consigneeAttached;
          },
          shipperAttached: function () {
            return permissions.shipperAttached;
          }
        },
        loadUrl: `${window._env_.REACT_APP_APIS}/wm/Transaction/GetCustomerLookupPaging`,
        onBeforeSend: (method, ajaxOptions) => {
          ajaxOptions.headers = {
            Authorization: `Bearer ${accessToken}`,
          };
        },
      }),
      filter: ['identityId', '=', identityId],
      paginate: true,
      pageSize: 100,
    });
    setDateSourceCustomer(dataSourceDB);
  }
  //////////Customer AutoComponent/////////////////////// 
  //////////Consignee AutoComponent///////////////////////
  const ConsigneeRef = useRef({});
  const [dateSourceConsignee, setDateSourceConsignee] = useState(null);
  const handleConsigneeChange = useCallback((e) => {

    console.log(e);
    setCustomerData(e.value);
    setConsigneeData(e.value);
    if (e.value != undefined) {
      setConsigneeInfo(getConsigneeInfo(e.value));
    }
    else {
      setConsigneeInfo("");
    }

  }, []);
  const loadConsigneeAutoComponentData = useCallback(() => {
    var permissions = checkUserPermissions();
    var dataSourceDB = new DataSource({
      store: new createStore({
        key: 'rowid',
        loadParams: {
          consigneeAttached: function () {
            return permissions.consigneeAttached;
          },
          shipperAttached: function () {
            return permissions.shipperAttached;
          }
        },
        loadUrl: `${window._env_.REACT_APP_APIS}/wm/Transaction/GetConsigneeLookupPaging`,
        onBeforeSend: function (method, ajaxOptions) {
          ajaxOptions.headers = {
            Authorization: `Bearer ${accessToken}`
          };
        }
      }),
      paginate: true,
      pageSize: 100
    });

    setDateSourceConsignee(dataSourceDB);
  }, []);
  const handelTransactionDateChange = (e) => {

    const name = "transactionDate";
    const value = e.value;
    setTransaction((prevTransaction) => ({
      ...prevTransaction,
      [name]: value,
    }));
  };

  const handelShippingDateChange = (e) => {
    const name = "actualreceivedshipeddate";
    const value = e.value;
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    if (props.oidc.user.profile.hasOwnProperty("WMTRANSDATECONTROL") && props.oidc.user.profile.WMTRANSDATECONTROL == "B") {
      if (value) {
        if (new Date(value) < today) {
          notify(
            {
              message: "Receiving date must be greater than today's date",
              width: 100,
            },
            'error',
            3000,
          );
          setTransaction((prevTransaction) => ({
            ...prevTransaction,
            [name]: null,
          }));
          return;
        }
      }
    }
    setTransaction((prevTransaction) => ({
      ...prevTransaction,
      [name]: value,
    }));
  };

  const ApplyFilterForConsigneeAutoComponent = (identityId) => {
    var permissions = checkUserPermissions();
    const dataSourceDB = new DataSource({
      store: new createStore({
        key: 'rowid',
        loadParams: {
          consigneeAttached: function () {
            return permissions.consigneeAttached;
          },
          shipperAttached: function () {
            return permissions.shipperAttached;
          }
        },
        loadUrl: `${window._env_.REACT_APP_APIS}/wm/Transaction/GetConsigneeLookupPaging`,
        onBeforeSend: (method, ajaxOptions) => {
          ajaxOptions.headers = {
            Authorization: `Bearer ${accessToken}`,
          };
        },
      }),
      filter: ['identityId', '=', identityId],
      paginate: true,
      pageSize: 100,
    });
    setDateSourceConsignee(dataSourceDB);
  }
  //////////Customer AutoComponent/////////////////////// 



  const handelSalesOrderChange = (e) => {

    const name = "transactionGroup";
    const value = e.value;
    setTransaction((prevTransaction) => ({
      ...prevTransaction,
      [name]: value,
    }));
  };

  const hideLoadPanel = useCallback(() => {
    setLoadPanelVisible(false);
  }, [setLoadPanelVisible]);

  const onBottomTabSelectionChanged = useCallback((e) => {
    if (e.fullName === 'selectedIndex') {
      setSelectedBottomTabIndex(e.value);
      // When Details tab is selected, ensure DataGrid is initialized and refreshed
      if (e.value === 1) {
        setTimeout(() => {
          if (detailDataGrid.current && typeof detailDataGrid.current.instance === 'function') {
            const instance = detailDataGrid.current.instance();
            if (instance) {
              instance.option('dataSource', detailDataSource);
              instance.refresh();
            }
          }
        }, 200);
      }
    }
  }, []);

  return (
    <div style={{ height: 'calc(100vh - 67px)', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
      <LoadPanel
        shadingColor="rgba(0,0,0,0.4)"
        position={position}
        onHiding={hideLoadPanel}
        visible={loadPanelVisible}
        showIndicator={showIndicator}
        shading={shading}
        showPane={showPane}
        hideOnOutsideClick={hideOnOutsideClick}
      />
      <div className="row" style={{ flex: 1, minHeight: '100%', height: '100%', display: 'flex', flexDirection: 'column', margin: 0, overflow: 'hidden' }}>
        <div className="col-md-12 main-page" style={{ flex: 1, minHeight: '100%', height: '100%', display: 'flex', flexDirection: 'column', overflow: 'hidden', padding: 0 }}>
          <div id="accordion" style={{ flex: 1, minHeight: 0, height: '100%', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
            <form onSubmit={(e) => onSaveTransaction(e)} style={{ flex: 1, minHeight: 0, height: '100%', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
              <AccordionReact
                dataSource={searchpanel}
                collapsible={true}
                multiple={false}
                animationDuration={300}
                selectedItems={selectedItems}
                onSelectionChanged={e => {
                  if (e.currentTarget === e.target) {
                    selectionChanged(e, e.target);
                  }
                }}
                defaultSelectedItems={[searchpanel[0]]}
                style={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column', overflow: 'hidden', height: '100%' }}
                itemTitleRender={() => (
                  <ToolbarAccordian className="accordian-toolbar">
                    <ItemAccordian location="before">
                      <div className="title">
                        <h6
                          style={{
                            color: window._env_.Color2
                          }}
                        >
                          {props.rolePermission === PermissionsConstants.TransactionReceipt
                            ? "Create New Receipt "
                            : "Create New Shipment"}
                        </h6>
                      </div>
                    </ItemAccordian>
                    <ItemAccordian location="after">
                      <Button className="accordianButton" text="Save" type="default"
                          disabled={isOrderCompleted}
                          onClick={(e) => onSaveTransaction(e)} />
                    </ItemAccordian>
                    <ItemAccordian location="after">
                      {(props.rolePermission === PermissionsConstants.TransactionReceipt && allowedReceiptDeleteBtn) || allowedShipmentDeleteBtn ?
                        (
                          <div>
                            <Button
                              onClick={(e) => handleOpenDeleteReceiptDialog(e)}

                              className="accordianButton"
                              disabled={deleteButtonDisabled}
                              text="Delete"
                              type="default"
                            >
                            </Button>
                            <DeleteReceiptDialog
                              open={deleteReceiptDialogOpen}
                              handleClose={handleCloseDeleteReceiptDialog}
                              rowid={receiptId}
                              transactionNumber={transaction.transactionNumber}
                            />
                          </div>
                        )
                        : ("")
                      }
                    </ItemAccordian>
                    <ItemAccordian location="after">
                      <Button className="accordianButton" text="Confirm Order" type="default"
                        disabled={receiptId === "" || isOrderCompleted} onClick={(e) => handleCompleteOrder(e)} />
                    </ItemAccordian>
                     
                    <ItemAccordian location="after">
                      <Button
                        className="accordianButton"
                        onClick={(e) => exportReport(e)}
                        disabled={printButtonDisabled}
                      >
                        <LoadIndicator style={{ height: "16px", width: "16px", display: "inline-bloc", verticalAlign: "middle", marginRight: "5px" }} visible={loadIndicatorVisible} />
                        <span className="dx-button-text">Print</span>
                      </Button>
                    </ItemAccordian>
                    <ItemAccordian location="after">
                      <Button className="accordianButton" text="Back" onClick={backToMainGrid} />
                    </ItemAccordian>
                  </ToolbarAccordian>
                )}
                itemRender={(itemProps) => (
                  <div style={{ flex: 1, minHeight: '100%', height: '100%', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
                    {/* Tab Panel - Primary and Details inside accordion */}
                    <TabPanel
                      id="create-receipt-tabpanel"
                      className="TabpanelContainer create-receipt-tabpanel"
                      style={{ flex: 1, minHeight: '100%', height: '100%', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}
                      onOptionChanged={onBottomTabSelectionChanged}
                      selectedIndex={selectedBottomTabIndex}
                      deferRendering={false}
                    >
                      {/* Primary Tab - Form fields */}
                      <TabItem title="Primary">
                        <div style={{ flex: 1, minHeight: 0, overflowY: 'auto', paddingBottom: '12px' }}>
                          {props.oidc.user.profile.hasOwnProperty("LOGINTYPEID") && props.oidc.user.profile.LOGINTYPEID == ABECASUSER_LOGIN_TYPE ?
                            <div className="row">
                              <div className="col-md-3 d-flex align-items-center ">
                                <div className="col-md-11 auto-complete-selectbox">
                                  <SelectBox
                                    dataSource={dateSourceProfile}
                                    value={profileData}
                                    searchEnabled={true}
                                    disabled={profileDisabled || isOrderCompleted}
                                    searchMode="contains"
                                    onValueChanged={(e) => handleProfileChange(e)}

                                    label="Profile Code:"
                                    labelMode='static'
                                    stylingMode='outlined'
                                    displayExpr="code"
                                  >
                                  </SelectBox>
                                </div>
                                {profileDisabled ? (
                                  <span></span>
                                ) : (
                                  <Button
                                    icon="search"
                                    disabled={isOrderCompleted}
                                    onClick={() => openProfileSearchIdsForm()}
                                    stylingMode="text"
                                  />
                                )}
                              </div>
                              <div className="col-md-3 d-flex align-items-center ">
                                <div className="col-md-11 auto-complete-selectbox">
                                  <SelectBox
                                    dataSource={dateSourceCustomer}
                                    value={customerData}
                                    searchEnabled={true}
                                    disabled={customerDisabled || isOrderCompleted}
                                    searchMode="contains"
                                    onValueChanged={(e) => handleCustomerChange(e)}
                                    label="Customer ID:"
                                    labelMode='static'
                                    stylingMode='outlined'
                                    displayExpr="identityId"

                                  >
                                  </SelectBox>
                                </div>

                                {customerDisabled ? (
                                  <span></span>
                                ) : (
                                  <Button
                                    icon="search"
                                    disabled={isOrderCompleted}
                                    onClick={() => openSearchIdsForm(customerLookup)}
                                    stylingMode="text"

                                  />

                                )}
                              </div>
                              <div className="col-md-3">
                                <DateBox
                                  stylingMode='outlined'
                                  labelMode="static"
                                  label="Transaction Date:"
                                  defaultValue=''
                                  type="date"
                                  name="transactionDate"
                                  disabled={isDisabled || isOrderCompleted}
                                  value={transaction.transactionDate}
                                  onValueChanged={(e) => handelTransactionDateChange(e)}
                                  showClearButton={true}
                                />
                                {transaction.transactionDate === "" ? (
                                  <span className="error-span">{dateError}</span>
                                ) : (
                                  <span></span>
                                )}
                              </div>
                              <div className="col-md-3">
                                <TextBox
                                  id="transactionNo"
                                  disabled
                                  name="transactionNumber"
                                  stylingMode='outlined'
                                  labelMode="static"
                                  label="Transaction No:"
                                  defaultValue=""
                                  value={transaction.transactionNumber}
                                />
                              </div>
                            </div>
                            :
                            <div className="row">
                              <div className="col-md-3">
                                <DateBox
                                  stylingMode='outlined'
                                  labelMode="static"
                                  label="Transaction Date:"
                                  defaultValue=''
                                  type="date"
                                  name="transactionDate"
                                  disabled={isDisabled || isOrderCompleted}
                                  value={transaction.transactionDate}
                                  onValueChanged={(e) => handelTransactionDateChange(e)}
                                  showClearButton={true}
                                />
                                {transaction.transactionDate === "" ? (
                                  <span className="error-span">{dateError}</span>
                                ) : (
                                  <span></span>
                                )}
                              </div>
                              <div className="col-md-3">
                                <TextBox
                                  id="transactionNo"
                                  disabled
                                  name="transactionNumber"
                                  stylingMode='outlined'
                                  labelMode="static"
                                  label="Transaction No:"
                                  defaultValue=""
                                  value={transaction.transactionNumber}
                                />
                              </div>
                              <div className="col-md-3 d-flex align-items-center ">
                                <div className="col-md-11 auto-complete-selectbox">
                                  <SelectBox
                                    dataSource={dataSource}
                                    value={carrierData}
                                    searchEnabled={true}
                                    searchMode="contains"
                                  disabled={isOrderCompleted}
                                  onValueChanged={(e) => handleCarrierChange(e)}
                                  label="Carrier ID:"
                                  labelMode='static'
                                  stylingMode='outlined'
                                  displayExpr="identityId"
                                  />
                                </div>
                                <Button
                                  icon="search"
                                  disabled={isOrderCompleted}
                                  onClick={() => openSearchIdsForm(carrierLookup)}
                                  stylingMode="text"
                                />
                              </div>
                              <div className="col-md-3">
                                <TextBox
                                  id="transaction-reference"
                                  name="reference"
                                  stylingMode='outlined'
                                  labelMode="static"
                                  label="P.O. No:"
                                  defaultValue=""
                                  value={transaction.reference}
                                  disabled={isOrderCompleted}
                                  onValueChanged={(e) => handelreferenceChange(e)}
                                >
                                </TextBox>
                              </div>
                            </div>
                          }
                          <div className="row accordianLastRow">
                            <div className="col-md-3 d-flex align-items-center ">
                              {props.rolePermission === PermissionsConstants.TransactionReceipt ? (
                                <div className="col-md-11 auto-complete-selectbox"  >
                                  <SelectBox
                                    dataSource={dateSourceConsignee}
                                    value={consigneeData}
                                    disabled={consigneeIdInputToDisable || isOrderCompleted}
                                    searchEnabled={true}
                                    searchMode="contains"
                                    onValueChanged={(e) => handleConsigneeChange(e)}
                                    label="Consignee ID:"
                                    labelMode='static'
                                    stylingMode='outlined'
                                    displayExpr="identityId"
                                  >
                                  </SelectBox>
                                </div>
                              )
                                :
                                (
                                  <div className="col-md-9 auto-complete-selectbox">
                                    <SelectBox
                                      dataSource={dateSourceConsignee}
                                      value={consigneeData}
                                      disabled={consigneeIdInputToDisable}
                                      searchEnabled={true}
                                      searchMode="contains"
                                      onValueChanged={(e) => handleConsigneeChange(e)}
                                      label="Consignee ID:"
                                      labelMode='static'
                                      stylingMode='outlined'
                                      displayExpr="identityId"

                                    >
                                    </SelectBox>
                                  </div>
                                )
                              }

                              {renderConsigneeSearchButton(consigneeSearchDisable)}
                              {props.rolePermission === PermissionsConstants.TransactionReceipt ? (
                                ""
                              ) : props.oidc.user.profile.hasOwnProperty("CREATECONSIGNEE") && props.oidc.user.profile.CREATECONSIGNEE === "Y" ? (
                                <div >
                                  <Button id="btnAddConsignee" className="accordianButton custom-button_min_width" disabled={isOrderCompleted} onClick={handleClicPopUpkOpen} type="default" text="Add">
                                  </Button>

                                </div>
                              ) : null}
                            </div>
                            <div className="col-md-3 d-flex align-items-center ">
                              <div className="col-md-11 auto-complete-selectbox">
                                <SelectBox
                                  dataSource={dateSourceSupplier}
                                  value={shipperData}
                                  searchEnabled={true}
                                  searchMode="contains"
                                  disabled={isOrderCompleted}
                                  onValueChanged={(e) => handleShipperChange(e)}
                                  label="Shipper ID:"
                                  labelMode='static'
                                  stylingMode='outlined'
                                  displayExpr="identityId"
                                >
                                </SelectBox>
                              </div>
                              <Button
                                icon="search"
                                disabled={isOrderCompleted}
                                onClick={() => openSearchIdsForm(1)}
                                stylingMode="text"

                              />


                            </div>
                            <div className="col-md-3">
                              <TextBox
                                id="transactionNo"
                                name="shipperBolNumber"
                                stylingMode='outlined'
                                labelMode="static"
                                label="Shipper BOL:"
                                defaultValue=""
                                value={transaction.shipperBolNumber}
                                disabled={isOrderCompleted}
                                onValueChanged={(e) => handelShipperBolChange(e)}
                              />
                            </div>

                            {(props.oidc.user.profile.hasOwnProperty("RECVSHIPDTACCESS") && props.oidc.user.profile.RECVSHIPDTACCESS == "A") ? (
                              <div className="col-md-3">
                                <DateBox
                                  stylingMode='outlined'
                                  labelMode="static"
                                  label="Receiving/Shipping Date:"
                                  defaultValue=''
                                  type="date"
                                  name="actualreceivedshipeddate"
                                  value={transaction.actualreceivedshipeddate}
                                  disabled={disableReciveShippingDate || isOrderCompleted}
                                  onValueChanged={(e) => handelShippingDateChange(e)}
                                  showClearButton={true}
                                />
                                {/* {transaction.actualreceivedshipeddate === "" ? (
                            <span className="error-span">{dateError}</span>
                          ) : (
                            <span></span>
                          )} */}
                              </div>
                            ) : (props.oidc.user.profile.hasOwnProperty("RECVSHIPDTACCESS") && props.oidc.user.profile.RECVSHIPDTACCESS == "B") ? (
                              <div className="col-md-3">
                                <DateBox
                                  stylingMode='outlined'
                                  labelMode="static"
                                  label="Receiving/Shipping Date:"
                                  defaultValue=''
                                  type="date"
                                  name="actualreceivedshipeddate"
                                  value={transaction.actualreceivedshipeddate}
                                  disabled={disableReciveShippingDate || isOrderCompleted}
                                  onValueChanged={(e) => handelShippingDateChange(e)}
                                />
                              </div>
                            ) : ""}





                          </div>
                          <div className="row accordianLastRow">
                            <div className="col-md-3">
                              <TextArea
                                value={consigneeInfo}
                                label="Consignee Info"
                                labelMode='static'
                                stylingMode='outlined'
                                readOnly={true}
                              />

                            </div>
                            <div className="col-md-3">
                              <TextArea
                                name="comment"
                                value={transaction.comment}
                                disabled={isOrderCompleted}
                                onValueChanged={(e) => handelCommentChange(e)}
                                label="Comment"
                                labelMode='static'
                                stylingMode='outlined'
                              >
                              </TextArea>
                            </div>
                            {props.oidc.user.profile.hasOwnProperty("LOGINTYPEID") &&
                              props.oidc.user.profile.LOGINTYPEID === ABECASUSER_LOGIN_TYPE && (
                                <>
                                  <div className="col-md-3 d-flex  ">
                                    <div className="col-md-11 auto-complete-selectbox">
                                      <SelectBox
                                        dataSource={dataSource}
                                        value={carrierData}
                                        searchEnabled={true}
                                        searchMode="contains"
                                        onValueChanged={(e) => handleCarrierChange(e)}
                                        label="Carrier ID:"
                                        labelMode="static"
                                        stylingMode="outlined"
                                        displayExpr="identityId"
                                      />
                                    </div>
                                    <Button
                                      icon="search"
                                      onClick={() => openSearchIdsForm(carrierLookup)}
                                      stylingMode="text"
                                      style={{ paddingTop: '10px' }}
                                    />
                                  </div>
                                  <div className="col-md-3">
                                    <TextBox
                                      id="transaction-reference"
                                      name="reference"
                                      stylingMode="outlined"
                                      labelMode="static"
                                      label="P.O. No:"
                                      defaultValue=""
                                      value={transaction.reference}
                                      onValueChanged={(e) => handelreferenceChange(e)}
                                    />
                                  </div>
                                </>
                              )}
                            {props.rolePermission === PermissionsConstants.TransactionShipment
                              ?
                              <div className={`col-md-3 ${isAbecasUser ? 'accordianLastRow' : ''}`}>
                                <div className="col-md-12 auto-complete-selectbox">
                                  <SelectBox
                                    items={[
                                      { Name: "None", tab: 0, ID: "N" },
                                      { Name: "Prepaid", tab: 1, ID: "P" },
                                      { Name: "Collect", tab: 2, ID: "C" },
                                      { Name: "Bill Third Party", tab: 3, ID: "B" }
                                    ]}
                                    searchMode="contains"
                                    label="Freight Charge Type:"
                                    labelMode='static'
                                    stylingMode='outlined'
                                    displayExpr="Name"
                                    valueExpr="ID"
                                    onValueChanged={onItemClick}
                                    defaultValue="N"
                                  >
                                  </SelectBox>
                                </div>

                              </div>
                              : ""}

                            {
                              props.rolePermission === PermissionsConstants.TransactionShipment ?
                                <div className={`col-md-3 ${isAbecasUser ? 'accordianLastRow' : ''}`}>
                                  <TextBox
                                    id="transactionGroup"
                                    name="transactionGroup"
                                    stylingMode='outlined'
                                    labelMode="static"
                                    label="Sales Order No:"
                                    defaultValue=""
                                    value={transaction.transactionGroup}
                                    onValueChanged={(e) => handelSalesOrderChange(e)}
                                  />
                                </div> : null
                            }
{props.rolePermission === PermissionsConstants.TransactionShipment
                        ?
                        <div className={`col-md-3 ${isAbecasUser ? 'accordianLastRow' : ''}`}>
                        <TextBox
                          id="userDefinedReference2"
                          name="userDefinedReference2"
                          stylingMode='outlined'
                          labelMode="static"
                          label={Localization.formatMessage('WMTRANSACTIONHEADER.USERDEFINEDREFERENCE_2', 'Trucker Ref:')}
                          defaultValue=""
                          value={transaction.userDefinedReference2}
                          onValueChanged={(e) => handelUerDefinedReference2rChange(e)}
                        />
                      </div>
                        : ""}

                          </div>
                        </div>
                        <div style={{ display: 'flex', border: '0px solid black', marginTop: '12px' }}>
                          <div style={{ flex: 1, padding: '2px', marginLeft: '15px', width: '10vw', borderTopLeftRadius: '12px', border: '1px solid ' + (window._env_.Color2), backgroundColor: window._env_.Color2, color: 'white', textAlign: 'center' }}>
                            Record #:
                          </div>
                          <div style={{ flex: 1, padding: '2px', width: '10vw', borderTop: '1px solid ' + (window._env_.Color2), borderLeft: '1px solid ' + (window._env_.Color2), borderRight: '1px solid ' + (window._env_.Color2), color: 'black', textAlign: 'center' }}>
                            {transaction.recordNumber || ''}
                          </div>
                          <div style={{ flex: 1, padding: '2px', width: '10vw', border: '1px solid ' + (window._env_.Color2), backgroundColor: window._env_.Color2, color: 'white', textAlign: 'center' }}>
                            Total Lines:
                          </div>
                          <div style={{ flex: 1, padding: '2px', width: '10vw', borderTop: '1px solid ' + (window._env_.Color2), borderLeft: '1px solid ' + (window._env_.Color2), borderRight: '1px solid ' + (window._env_.Color2), color: 'black', textAlign: 'center' }}>
                            {selectedTotals.items}
                          </div>
                          <div style={{ flex: 1, padding: '2px', width: '10vw', border: '1px solid ' + (window._env_.Color2), backgroundColor: window._env_.Color2, color: 'white', textAlign: 'center' }}>
                            Ordered:
                          </div>
                          <div style={{ flex: 1, padding: '2px', width: '10vw', borderTop: '1px solid ' + (window._env_.Color2), borderLeft: '1px solid ' + (window._env_.Color2), borderRight: '1px solid ' + (window._env_.Color2), color: 'black', textAlign: 'center' }}>
                            {selectedTotals.ordered}
                          </div>
                          <div style={{ flex: 1, padding: '2px', width: '10vw', border: '1px solid ' + (window._env_.Color2), backgroundColor: window._env_.Color2, color: 'white', textAlign: 'center' }}>
                            Actual:
                          </div>
                          <div style={{ flex: 1, padding: '2px', marginRight: '15px', width: '10vw', borderTopRightRadius: '12px', borderTop: '1px solid ' + (window._env_.Color2), borderLeft: '1px solid ' + (window._env_.Color2), borderRight: '1px solid ' + (window._env_.Color2), color: 'black', textAlign: 'center' }}>
                            {selectedTotals.actual}
                          </div>
                        </div>
                        <div style={{ display: 'flex', border: '0px solid black', marginBottom: '12px' }}>
                          <div style={{ flex: 1, padding: '2px', marginLeft: '15px', width: '10vw', borderBottomLeftRadius: '12px', border: '1px solid ' + (window._env_.Color2), backgroundColor: window._env_.Color2, color: 'white', textAlign: 'center' }}>
                            Net Weight:
                          </div>
                          <div style={{ flex: 1, padding: '2px', width: '10vw', border: '1px solid ' + (window._env_.Color2), color: 'black', textAlign: 'center' }}>
                            {selectedTotals.netWeight}
                          </div>
                          <div style={{ flex: 1, padding: '2px', width: '10vw', border: '1px solid ' + (window._env_.Color2), backgroundColor: window._env_.Color2, color: 'white', textAlign: 'center' }}>
                            Gross Weight:
                          </div>
                          <div style={{ flex: 1, padding: '2px', width: '10vw', border: '1px solid ' + (window._env_.Color2), color: 'black', textAlign: 'center' }}>
                            {selectedTotals.grossWeight}
                          </div>
                          <div style={{ flex: 1, padding: '2px', width: '10vw', border: '1px solid ' + (window._env_.Color2), backgroundColor: window._env_.Color2, color: 'white', textAlign: 'center' }}>
                            Amount:
                          </div>
                          <div style={{ flex: 1, padding: '2px', width: '10vw', border: '1px solid ' + (window._env_.Color2), color: 'black', textAlign: 'center' }}>
                            {selectedTotals.amount}
                          </div>
                          <div style={{ flex: 1, padding: '2px', width: '10vw', border: '1px solid ' + (window._env_.Color2), backgroundColor: window._env_.Color2, color: 'white', textAlign: 'center' }}>
                          </div>
                          <div style={{ flex: 1, padding: '2px', marginRight: '15px', width: '10vw', borderBottomRightRadius: '12px', border: '1px solid ' + (window._env_.Color2), color: 'black', textAlign: 'center' }}>
                            &nbsp;
                          </div>
                        </div>
                      </TabItem>
                      {/* Details Tab - Grid section */}
                      <TabItem title="Details" disabled={!receiptId}>
                        <ItemModeGrid
                          key={reloadKey}
                          displayItemModeGrid={displayItemModeGrid}
                          detailDataGridModes={detailDataGridModes}
                          selectedValue={selectedValue}
                          detailDataGridModeChanged={detailDataGridModeChanged}
                          searchPanelStatus={searchPanelStatus}
                          headerId={headerId}
                          selectedCustomerId={selectedCustomerId}
                        />
                        {/* Grids Container - Takes remaining space */}
                        <div className="search-page-grid-container">
                          <DataGrid
                            onExporting={(e) => {
                              if (window.handleDevExtremeDataGridExport) {
                                window.handleDevExtremeDataGridExport(e);
                              }
                            }}
                            id="girdIdAvailableItems"
                            remoteOperations={true}
                            showBorders={true}
                            ref={detailDataGrid}
                            dataSource={detailDataSource}
                            hoverStateEnabled={true}
                            allowColumnResizing={true}
                            allowColumnReordering={true}
                            columnAutoWidth={true}
                            className="search-page-grid"
                            style={{ height: '38vh' }}
                            scrolling={{ mode: 'standard', showScrollbar: 'always' }}
                            onRowUpdating={(e) => onChangeReceiptQuantityUpdate(e)}
                            onRowUpdated={onRowUpdated}
                            onSaved={(e) => onSaved(e)}
                            onSelectionChanged={onAvailableItemsSelectionChanged}
                            onContentReady={(e) => {
                              onContentReady(e);
                              // Ensure dataSource is set when grid is ready
                              if (detailDataGrid.current && typeof detailDataGrid.current.instance === 'function') {
                                const instance = detailDataGrid.current.instance();
                                if (instance && !instance.option('dataSource')) {
                                  instance.option('dataSource', detailDataSource);
                                }
                              }
                            }}
                          >
                            <Selection mode="single" />
                            <ColumnChooser
                              enabled={true}
                              title="Choose Column"
                              width={290}
                              height={290}
                              sortOrder="asc"
                            >
                              <ColumnChooserSearch
                                enabled={true}
                                editorOptions={{ placeholder: 'Search column' }} />
                            </ColumnChooser>
                            <ColumnFixing enabled={true} />
                            <ColumnHeaderFilter />
                            <Export enabled={true} allowExportSelectedData={true} text="Export" />
                            <Sorting visible={true} mode="multiple" />
                            <LoadPanel enabled={true} />
                            <Paging defaultPageSize={100} />
                            <Pager
                              visible={true}
                              showPageSizeSelector={true}
                              allowedPageSizes={allowedPageSizes}
                              showNavigationButtons={true}
                            />
                            <FilterRow visible={true} />
                            <Editing mode="cell" allowUpdating={!isOrderCompleted} refreshMode="repaint" />
                            <FilterPanel visible={true} />
                            <HeaderFilter visible={true} />
                            <GroupPanel visible={true} />
                            <Grouping autoExpandAll={false} />
                            <StateStoring
                              enabled={true}
                              type="custom"
                              customLoad={loadState}
                              storageKey={gridKey}
                              customSave={saveState}
                            />
                            {/* Available Items Grid - Only 5 columns visible in specific order */}
                            {/* 1. Item */}
                            <Column
                              dataField="itemcode"
                              caption="Item"
                              allowEditing={false}
                            ></Column>
                            {/* 2. Item Description - 1 */}
                            <Column
                              dataField="description1"
                              caption="Item Description - 1"
                              allowEditing={false}
                            ></Column>
                            {/* 3. Lot */}
                            <Column 
                              dataField="lotcode" 
                              caption="Lot" 
                              allowEditing={false}
                            ></Column>
                            {/* 4. Net Avl. */}
                            <Column
                              dataField="netavailable"
                              caption="Net Avl."
                              allowEditing={false}
                            ></Column>
                            {/* 5. Ordered Quantity */}
                            <Column
                              dataField="quantityorder"
                              dataType="number"
                              caption="Ordered Quantity"
                              allowEditing={!isOrderCompleted}
                            ></Column>
                            
                            <Column dataField="classcode" caption="Class" allowEditing={false} visible={false}></Column>
                            <Column dataField="palletsizecode" caption="PalletSizeCode" allowEditing={false} visible={false}></Column>
                            <Column dataField="subclasscode" caption="SubClass" allowEditing={false} visible={false}></Column>
                            <Column dataField="status" caption="Status" allowEditing={false} visible={false}></Column>
                            <Column dataType="date" dataField="dateavailable" caption="Item Date Available" allowEditing={false} visible={false}></Column>
                            <Column dataType="date" dataField="dateexpiration" caption="Item Date Expiration" allowEditing={false} visible={false}></Column>
                            <Column dataField="receiptuomdefault" caption="UOM Default" allowEditing={false} visible={false}></Column>
                            <Column dataField="receiptpacksize" caption="Pack Size" allowEditing={false} visible={false}></Column>
                            <Column dataField="lotDescription1" caption="Lot Description - 1" allowEditing={false} visible={false}></Column>
                            <Column dataField="lotDescription2" caption="Lot Description - 2" allowEditing={false} visible={false}></Column>
                            <Column dataField="lotUserdefinedreference8" caption="Lot Reference 8" allowEditing={false} visible={false}></Column>
                            <Column dataField="lotNetavailable" caption="Lot Net Avl" allowEditing={false} visible={false}></Column>
                            <Column dataType="date" dataField="lotDateExpiration" caption="Lot Date Expiration" allowEditing={false} visible={false}></Column>
                            <Column dataType="date" dataField="LotDateAvailable" caption="Lot Date Available" allowEditing={false} visible={false}></Column>
                            <Column dataType="date" dataField="LotDateIntroduced" caption="Lot Date Introduced" allowEditing={false} visible={false}></Column>
                            <Column dataField="lotUnitPerPackage" caption="Lot Units / Package" allowEditing={false} visible={false}></Column>
                            <Column dataField="lotFirstReceipt" caption="Lot First Receipt" allowEditing={false} visible={false}></Column>
                            <ColumnChooser enabled={true}>
                              <ColumnChooserSearch enabled={true} />
                            </ColumnChooser>
                            <Scrolling mode="standard" showScrollbar="auto" />
                            <Sorting mode="multiple" />
                            <Paging defaultPageSize={50} />
                            <Toolbar>
                              <Item location="before">
                                <h6 style={{ margin: 0, color: window._env_?.Color2 || '#333' }}>Available Items</h6>
                              </Item>
                              <Item>
                                <SelectBox
                                  width="201"
                                  stylingMode='outlined'
                                  items={detailDataGridModes}
                                  displayExpr="text"
                                  valueExpr="value"
                                  value={selectedValue}
                                  onValueChanged={detailDataGridModeChanged} />
                              </Item>
                              <Item location="after">
                                <GridLayoutManager gridKey={gridKey} dataGrid={detailDataGrid} setCurrentLayout={setCurrentLayout} />
                              </Item>
                              <Item name="exportButton" />
                              <Item name="columnChooserButton" />
                            </Toolbar>
                          </DataGrid>
                        </div>
                        <div className="search-page-grid-container">
                        <DataGrid
                            onExporting={(e) => {
                              if (window.handleDevExtremeDataGridExport) {
                                window.handleDevExtremeDataGridExport(e);
                              }
                            }}
                            id="girdIdOrderedItems"
                            remoteOperations={false}
                            showBorders={true}
                            ref={detailOrderedItemsDataGrid}
                            dataSource={orderedItemsDataSource}
                            hoverStateEnabled={true}
                            allowColumnResizing={true}
                            allowColumnReordering={true}
                            columnAutoWidth={true}
                            className="search-page-grid"
                            style={{ height: '38vh', marginTop: '8px' }}
                            scrolling={{ mode: 'standard', showScrollbar: 'always' }}
                            onRowUpdating={(e) => onChangeOrderedItemsQuantityUpdate(e)}
                            onRowUpdated={onRowUpdated}
                            onRowRemoving={(e) => onOrderedItemsRowRemoving(e)}
                            onRowRemoved={(e) => onOrderedItemsRowRemoved(e)}
                            onSaved={(e) => onSaved(e)}
                            onContentReady={(e) => {
                              // Ensure dataSource is set when grid is ready
                              if (detailOrderedItemsDataGrid.current && typeof detailOrderedItemsDataGrid.current.instance === 'function') {
                                const instance = detailOrderedItemsDataGrid.current.instance();
                                if (instance && !instance.option('dataSource')) {
                                  instance.option('dataSource', orderedItemsDataSource);
                                }
                              }
                            }}
                          >
                            <ColumnChooser
                              enabled={true}
                              title="Choose Column"
                              width={290}
                              height={290}
                              sortOrder="asc"
                            >
                              <ColumnChooserSearch
                                enabled={true}
                                editorOptions={{ placeholder: 'Search column' }} />
                            </ColumnChooser>
                            <ColumnFixing enabled={true} />
                            <ColumnHeaderFilter />
                            <Export enabled={true} allowExportSelectedData={true} text="Export" />
                            <Sorting visible={true} mode="multiple" />
                            <LoadPanel enabled={true} />
                            <Paging defaultPageSize={100} />
                            <Pager
                              visible={true}
                              showPageSizeSelector={true}
                              allowedPageSizes={allowedPageSizes}
                              showNavigationButtons={true}
                            />
                            <Editing mode="cell" allowUpdating={!isOrderCompleted} allowDeleting={!isOrderCompleted} confirmDelete={false} refreshMode="repaint" />
                            <FilterPanel visible={false} />
                            <HeaderFilter visible={false} />
                            <GroupPanel visible={false} />
                            <Grouping autoExpandAll={false} />
                             
                            {/* Ordered Items Grid Columns */}
                            {/* Line Number Column - First */}
                            <Column
                              dataField="lineNumber"
                              caption="#"
                              dataType="number"
                              allowEditing={false}
                              width={60}
                              sortOrder="asc"
                            ></Column>
                            {/* 1. Item */}
                            <Column
                              dataField="itemcode"
                              caption="Item"
                              allowEditing={false}
                            ></Column>
                            {/* 2. Item Description - 1 */}
                            <Column
                              dataField="description1"
                              caption="Item Description - 1"
                              allowEditing={false}
                            ></Column>
                            {/* 3. Lot */}
                            <Column 
                              dataField="lotcode" 
                              caption="Lot" 
                              allowEditing={false}
                            ></Column>
                            {/* 4. Net Avl. */}
                            <Column
                              dataField="netavailable"
                              caption="Net Avl."
                              allowEditing={false}
                            ></Column>
                            {/* 5. Ordered Quantity - Editable */}
                            <Column
                              dataField="quantityorder"
                              dataType="number"
                              caption="Ordered Quantity"
                              allowEditing={!isOrderCompleted}
                            ></Column>
                            
                            <ColumnChooser enabled={true}>
                              <ColumnChooserSearch enabled={true} />
                            </ColumnChooser>
                            <Scrolling mode="standard" showScrollbar="auto" />
                            <Sorting mode="multiple" />
                            <Paging defaultPageSize={50} />
                            <Toolbar>
                              <Item location="before">
                                <h6 style={{ margin: 0, color: window._env_?.Color2 || '#333' }}>Ordered Items</h6>
                              </Item>
                              <Item>
                                <SelectBox
                                  width="201"
                                  stylingMode='outlined'
                                  items={detailDataGridModes}
                                  displayExpr="text"
                                  valueExpr="value"
                                  value={selectedValue}
                                  onValueChanged={detailDataGridModeChanged} />
                              </Item>
                              <Item location="after">
                                <GridLayoutManager gridKey={gridKey} dataGrid={detailDataGrid} setCurrentLayout={setCurrentLayout} />
                              </Item>
                              <Item name="exportButton" />
                              <Item name="columnChooserButton" />
                            </Toolbar>
                          </DataGrid>
                        </div>

                      </TabItem>
                    </TabPanel>
                  </div>
                )}
                id="accordion-container"
              />
            </form>
          </div>
        </div>
      </div>
      <div style={{ flex: 1 }}>
        <div className="row">
          <div className="d-flex ">
            <LookupPopup
              openLookupForm={openLookupForm}
              closeLookupSearchForm={closeLookupSearchForm}
              onSearchLookupIds={onSearchLookupIds}
              resetLookupForm={resetLookupForm}
              onLookupFieldChange={onLookupFieldChange}
              identityIdFrom={identityIdFrom}
              identityIdTo={identityIdTo}
              name={name}
              lookupFormName={lookupFormName}
              lookupDataList={lookupDataList}
              dataGrid={dataGrid}
              onSelectionChanged={onSelectionChanged}
            />
            <LookupProfilePopup
              openLookupForm={openProfileLookupForm}
              closeLookupSearchForm={closeProfileLookupSearchForm}
              onSearchLookupIds={onSearchProfileLookupIds}
              resetLookupForm={resetProfileLookupForm}
              onLookupFieldChange={onProfileLookupFieldChange}
              code={code}
              description={description}
              lookupFormName="Profile"
              lookupDataList={profileLookupDataList}
              dataGrid={profileDataGrid}
              onSelectionChanged={onProfileSelectionChanged}
            />
            <Popup
              visible={openDialogForTransaction}
              onHiding={handleClose}
              title={dialogMessage1}
              showCloseButton={true}
              width={600} // Adjust width as needed
              height="auto" // Adjust height as needed
              className="cDialog"
            >
              <div className="row">
                <div className="col-12 d-flex justify-content-between p-0">

                </div>
              </div>
              <h5
                style={{
                  fontWeight: "500",
                  marginTop: "10px",
                }}
              >
                {dialogMessage2}
              </h5>

              <div
                style={{
                  display: 'flex',
                  justifyContent: 'flex-start',
                  marginLeft: '0px',
                  marginTop: '30px',
                }}
              >
                <Button
                  onClick={onUpdateTransaction}
                  className="accordianButton"
                  text="Add Details" type="default"
                >
                </Button>

                <Button
                  onClick={createNewReceiptAgain}
                  className="accordianButton"
                  text="New"
                >
                </Button>
                <Button
                  onClick={closeDialogForTransaction}
                  className="accordianButton"
                  text="Back"
                >

                </Button>

              </div>
            </Popup>

            {addConsigneePopup &&
              <Popup
                visible={addConsigneePopup}
                onHiding={hideConsigneePopup}
                dragEnabled={false}
                hideOnOutsideClick={true}
                showCloseButton={true}
                showTitle={true}
                title="Add Consignee"
                container="#root"
                closeOnOutsideClick={true}
                height="61vh"
                width="75vw"
              >
                <ScrollView width="100%" height="100%">
                  <Consignee
                    parentCallback={handleClosePopUpCallback}
                  ></Consignee>
                </ScrollView>
              </Popup>
            }
          </div>
        </div>
      </div>
    </div>
  );
}

function mapStateToProps(state) {
  return {
    ReceiptReducer: state.ReceiptReducer,
    oidc: state.oidc,
  };
}
export default connect(mapStateToProps)(CreateCustomerTransaction);
